import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { reduxPage } from '../../Core/store'
import { MAIN_CONFIG, dateDataType, dataTypeJoin, allDocType, notEditable, validateSelectTypeFields, enabledApplyButton } from '../../../config/main'
import ProgressBar from '../ProgressBar/ProgressBar'
import Close from '../../Components/SVG/Close'
import ApplicationHeader from './ApplicationHeader/ApplicationHeader'
import StepConfigForm from './StepConfigForm/StepConfigForm'
import ReferenceRoleForm from './ReferenceRoleForm/ReferenceRoleForm'
import ExternalRoleForm from './ExternalRoleForm/ExternalRoleForm'
import IterationForm from './IterationForm/IterationForm'
import Checkout from './Stripe/Stripe'
import PaymentDetails from './PaymentDetails/PaymentDetails'
import Calendar from '../SVG/Calendar'
import AirPlane from '../SVG/AirPlane'
import CTAButton from '../../Components/CTAButton/CTAButton';
import Loader, { CardListingLoader } from '../../Components/Loader/Loader';
import KaleidoscopeAPI from '../../Core/KaleidoscopeAPI';
import './application.scss'
import { isEmpty, cloneDeep, filter } from 'lodash';
import { toast } from 'react-toastify';
import FlashMessage from '../../Components/FlashMessage/Message';
import { isValidDateOfBirth } from '../../Utility/FormatDate';
import SweetAlert from 'react-bootstrap-sweetalert';
import { StripeProvider } from 'react-stripe-elements';
import { checkMarketPlace, checkDateFormats, convertDataFormat, formatDeadlineDate, useResponsiveState, handleRedirectHrefUrl, validateEmailRegex} from '../../Utility/HelperFunctions';
import RecommenderModal from '../../Components/AddRecommender/RecommenderModal';
import IterationModal from '../../Components/AddIteration/IterationModal';
import EnterLevelModal from './EnterLevelModal/EnterLevelModal';
import { useRouter } from 'next/router'
import { parseHtml, formatCurrency } from '../../Utility/HelperFunctions';
import { applicationFormAutoSuggestHiddenConfigs, setParamResponse, externalFinancialInformation, onChangeAnswer, skipConfigIds, skipConfigValue, checkRequiredWhen, containsVal, hasEqualVal, updateFormulaFieldAnswer, updateRollUpConfig, recommenderSkip, addressFieldsautofill, autoPopulateAnswersFromConfig, hideQuestionFiltered, mergeArrays, blankSpaceCheck, checkFieldLength, clearShowBackButtonSessionStorage, getDynamicClassName } from '../../Utility/ApplicationFormUtility';
import TearmsCondition from './TearmsAndCondition/TearmsAndCondition';
import cookies from 'next-cookies';
import ESignModal from '../ESignModal/ESignModal';
import { useDispatch } from 'react-redux';
import { setMateTagTitle } from '../../hooks/MateTagAction';
import EnterPasswordModal from './EnterPasswordModal/EnterPasswordModal';
import AppliedApplicationList from '../AppliedApplicationList/AppliedApplicationList';
import ParentConsentModal from './ParentConsentModal/ParentConsentModal';
import Alert from '../SVG/Alert';
import JumptoSection from './JumptoSection/JumptoSection';



/**
 * Application form
 *
 * @returns {ReactElement}
 */

const Application = ({ accountData, setModalState }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true);
  const [applicationData, setApplicationData] = useState({});
  const [fieldData, setFieldData] = useState([]);
  const [scholarship, setScholarship] = useState({});
  const [accountInfo, setAccountInfo] = useState({});
  const [application, setApplication] = useState({});
  const [firstTimeSubmit, setFirstTimeSubmit] = useState(false);
  const [cardLoader, setCardLoader] = useState(false);
  const { user } = accountData;
  const [parentScholarship, setParentScholarship] = useState(null);
  const [userCheck, setUserCheck] = useState('');
  const [recommenderfield, setRecommenderField] = useState([]);
  const [iterationData, setIterationData] = useState({});
  const [iterationfield, setIterationField] = useState([]);
  const [externalFinancial, setExternalFinancial] = useState([]);
  const [errors, setErrors] = useState([]);
  const [emailConfimation, setEmailConfimation] = useState('');
  const [emailConfimationErrors, setEmailConfimationErrors] = useState('');
  const [agreementModalOpen, setAgreementModalOpen] = useState(false)
  const [agreementFieldName, setAgreementFieldName] = useState("")
  const [filterFieldData, setFilterFieldData] = useState([]);
  const [recommenderButton, setRecommenderButton] = useState(false);
  const [iterationButton, setIterationButton] = useState(false);
  const [updateAlert, setUpdateAlert] = useState(false);
  const [entryLevel, setEntryLevel] = useState(false);
  const [envelopeId, setEnvelopeId] = useState("");
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false)
  const [isOpenPassword, setIsOpenPassword] = useState(false)
  const [isOpenLoginPassword, setIsOpenLoginPassword] = useState(false)
  const [password, setPassword] = useState('');
  const [thirteenYearAge, setThirteenYearAge] = useState(false);
  const [primaryColor, setPrimaryColour] = useState(MAIN_CONFIG.COLORS.fillGreen)
  const [sections, setSections] = useState([])
  const [errorsForSave, setErrorsForSave] = useState([])
  const [submittedSteps, setSubmittedSteps] = useState([])
  const [stepStatus, setStepStatus] = useState('')
  const [state, setState] = useState({
    errors: '',
    hasSymbol: false,
    hasUpperCase: false,
    hasLength: false,
    hasLowerCase: false,
    hasNumber: false,
  });
  const authToken = cookies('context').token || '';
  const isTextInputHaveMaxValue = (question) => {
    return question.data_type__c == "Text" && question.config_type__c == "Field" && question?.answer?.length > 255
  }
  const [buttonSecondaryColor, setButtonSecondaryColor] = useState(MAIN_CONFIG.COLORS.fillBlue);
  const { isMobileScreen, isIpadScreen } = useResponsiveState();
  const customScroll = document.getElementById('application-form-content-data')

  /**
   * Handle modal field value change.
   */
  const handleEmailConfirmation = (email, value) => {
    localStorage.setItem("isRedireactSave", true)
    if (email !== value) {
      setEmailConfimationErrors("Please confirm your email address.")
    } else {
      setEmailConfimationErrors("")
    }
    setEmailConfimation(value)
  }

  const [isCompleted, setIsCompleted] = useState(false)
  const router = useRouter();
  const { action } = router.query;
  const { scholarshipid, applicationstepid, applicationId } = router.query;
  const isClosedScholarship = scholarship.status__c === 'Closed';
  const allowsApplicantUploads = scholarship?.allow_applicant_uploads_after_deadline__c;
  const checkAccessCode = isClosedScholarship && allowsApplicantUploads;
  
  const close = () => {
    // TODO: Close application
    var isRediractLocal = localStorage.getItem("isRedireactSave") ? JSON.parse(localStorage.getItem("isRedireactSave")) : false

    if (isRediractLocal) {
      const getAlert = () => (
        <>
          <div className="save-changes-confirmation-alert modal-utility">
            <SweetAlert
              showConfirm={true}
              confirmBtnText="Okay"
              showCancel={true}
              cancelBtnText="Cancel"
              customButtons={
                <div className='action-footer'>
                  <button onClick={(e) => setUpdateAlert(false)} className='cta-button CTABlack cta-button__text'>Cancel</button>
                  <button onClick={(e) => {
                    exit();
                    localStorage.removeItem('hasAccessCode');
                    localStorage.removeItem('accessCode');
                  }}
                    className='cta-button CTAWhite tertiary cta-button__text'>Ok</button>
                </div>
              }
              className=""
            >
              <div style={{ display: 'flex' }}>
                <div>
                  <Alert />
                </div>
                <div className='content'>
                  <p className='title'>Are you sure you want to exit?</p>
                  <p className="CTAGrey">All changes will be lost if you leave this page without saving.</p>
                </div>
              </div>
            </SweetAlert>
          </div>
        </>
      );

      setUpdateAlert(getAlert)
    } else {
      exit()
    }

  }

  const handleClickViewAllStep = (url) => {
    // setLoading(true)
    var isRedirectLocal = localStorage.getItem("isRedireactSave") ? JSON.parse(localStorage.getItem("isRedireactSave")) : false

    if (isRedirectLocal) {
      alretMsgClickViewAllStep(url)
    } else {
      // window.location.href = 
      changeRoute(url)
    }
  }

  useEffect(() => {
    const showDefaultMessage = accountInfo?.scholarship_restriction_message__c || "The General Application must be completed prior to beginning this form"
    if (parentScholarship && userCheck !== 'APPLICANT') {
      const getAlert = () => (
        <div id='restriction-alert_message'>
        <SweetAlert
          warning
          confirmBtnCssClass="cta-button CTAWhite tertiary"
          onConfirm={() => redirectToParentScholarship()}
          id="copied-clipboard"
          confirmBtnText="Okay"
          title="Oops!"
        >
          {
            <p>
              {parseHtml(showDefaultMessage)}
            </p>
          }
        </SweetAlert>
        </div>
      );
      setUpdateAlert(getAlert);
    }
  }, [parentScholarship, userCheck]);
  
  useEffect(() => {
    // Simulate an asynchronous data fetch after 2 seconds
    const fetchParentScholarship = async () => {
      // Simulate fetching data
      await new Promise((resolve) => setTimeout(resolve, 2000));
      // Set the parent scholarship data when it's available
      setParentScholarship(scholarship.parent_scholarship_sfid);
  
      // Set userCheck from cookies
      const userCheckFromCookies = cookies('context').context;
      setUserCheck(userCheckFromCookies);
    };
  
    fetchParentScholarship();
  }, [scholarship.parent_scholarship_sfid]);

  const alretMsgClickViewAllStep = (val = '') => {
    setLoading(false)
    const getAlert = () => (
      <>
        <div className="save-changes-confirmation-alert modal-utility">
          <SweetAlert
            showConfirm={true}
            confirmBtnText="Okay"
            showCancel={true}
            cancelBtnText="Cancel"
            customButtons={
              <div className='action-footer'>
                <button onClick={(e) => setIsOpenSweetAlert(false)} className='cta-button CTABlack cta-button__text'>Cancel</button>
                <button onClick={(e) => { setIsOpenSweetAlert(false), changeRoute(val), localStorage.setItem("isRedireactSave", false) }} className='cta-button CTAWhite tertiary cta-button__text'>Ok</button>
              </div>
            }
            className=""
          >
            <div style={{ display: 'flex' }}>
              <div>
                <Alert />
              </div>
              <div className='content'>
                <p className='title'>Are you sure you want to exit?</p>
                <p className="CTAGrey">All changes will be lost if you leave this page without saving.</p>
              </div>
            </div>
          </SweetAlert>
        </div>
      </>
    );
    setIsOpenSweetAlert(getAlert)
  }
  const userContext = cookies('context').context
  const checkLogout = userContext === MAIN_CONFIG.USER_CONTEXT.LOGGED_OUT;
  const exit = (e) => {
    setLoading(true);
    localStorage.removeItem("secondaryColor");
    clearShowBackButtonSessionStorage()
    window.location.href = !userContext ? checkMarketPlace() : MAIN_CONFIG.URLS.APPLICANT.APPLICATIONS
  }

  const API = new KaleidoscopeAPI({});
  useEffect(() => {
    (async () => {
        setCardLoader(true)
        await fetchApplyScholarship()
        if (router?.query?.applicationId) {
          await fetchSetpsData()
        }
      })();
  }, [router.query.applicationstepid]);

  useEffect(() => {
    var country = cookies('/').country;
    // localStorage.setItem('secondaryColor', secondaryColor)
    const schList = scholarship.applicable_countries__c ? scholarship.applicable_countries__c?.split(';') : []
    if ((schList?.length > 0) && (router.query.applicationstepid && !router.query.applicationId)) {
      const isNotApplicable = !applicationId && (schList?.indexOf(country) < 0);
      if (isNotApplicable) {
        const getAlert = () => (
          <div id='alert-countries_model'>
          <SweetAlert
            warning
            confirmBtnCssClass="cta-button CTAWhite tertiary"
            cancelBtnCssClass="cta-button CTABlack"
            showCancel={true}
            cancelBtnText="Go Back"
            confirmBtnText="Continue Anyway"
            onConfirm={() => setUpdateAlert(false)}
            onCancel={() => redirectToGeneral()}
            id="copied-clipboard"
            title="Oops!"
          >
            <>
              <strong className="CTAGrey" style={{ margin: '10 10 10 10px', color: '#1a282c' }} >This scholarship is only available in the following countriesllll: {schList.join(', ')}.</strong>
            </>

          </SweetAlert>
          </div>
        );
        setUpdateAlert(getAlert)
      }
    }
  }, [scholarship]);

  const redirectToGeneral = () => {
    setLoading(true);
    window.location.href = '/'
    setUpdateAlert(false)
  }
  const redirectToParentScholarship = () => {
    setLoading(true);
    handleRedirectHrefUrl(`${scholarship.parent_scholarship_sfid ? '/scholarships/' + scholarship.parent_scholarship_sfid : '/'}`)
    setUpdateAlert(false)
  }
  const fetchSetpsData = async () => {
    setLoading(true)
    // alert('staepdata is fetched')
    const fetchedData = await API.fetchResumeScholarship({ 'token': accountData.token, scholarshipId: scholarshipid, applicationStepId: applicationstepid, applicationId: applicationId || '' })
    if (fetchedData.application) {
      setSections(fetchedData.application.steps_data)
      setSubmittedSteps(fetchedData.application.submitted_application_steps||[])
      setStepStatus(fetchedData.application.status__c)
    }
    setLoading(false)
    setCardLoader(false)
  }
  let primaryColorConvert = primaryColor?.toLowerCase();

  const fetchApplyScholarship = async (token = '', onCallBack=()=>{}) => {
    const response = await API.fetchApplyScholarship({ 'token': accountData.token || token, scholarshipId: scholarshipid, applicationStepId: applicationstepid, applicationId: applicationId || '' })
    if (response.application) {

      let arr = localStorage.getItem('accessCode')

      if (!response.scholarship.allow_applicant_uploads_after_deadline__c && notEditable.includes(response.scholarship?.status__c) && !arr) {
        const getAlert = () => (
          <SweetAlert
            warning
            show={true}
            confirmBtnText="Close"
            confirmBtnBsStyle="danger"
            onConfirm={() => onClose()}
            showConfirm={true}
            title={response.scholarship.status__c}
            customClass="user-confirmation-alert"
          >
            <p className="user-confirmation-alert__message">{`Scholarship is ${response.scholarship.status__c.toLowerCase()}`}.</p>
          </SweetAlert>
        );
        setUpdateAlert(getAlert())
        setLoading(false);
        return false
      }
      if (response.application.status__c === 'Ineligible') {
        const getAlert = () => (
          <SweetAlert
            warning
            show={true}
            confirmBtnText="Close"
            confirmBtnBsStyle="danger"
            onConfirm={() => onClose()}
            showConfirm={true}
            title={response.application.status__c}
            customClass="user-confirmation-alert"
          >
            <p className="user-confirmation-alert__message">{parseHtml(response.application.exit_reason__c)}</p>
          </SweetAlert>
        );
        setUpdateAlert(getAlert())
        setLoading(false);
        return false
      }

      if (response.application.steps_data && response.application.steps_data.fields) {
        response.application.steps_data.fields.map(config => {
          if (dateDataType.indexOf(config.data_type__c) > -1) {
            config.answer = config.answer ? convertDataFormat(config.answer, config.data_type__c) : config.answer
          }
        })
      }

      if(response.scholarship) {
        handleRedirectToResume(response.scholarship)
      }
      setApplication(response.application)
      setScholarship(response.scholarship)
      setAccountInfo(response.account)

      let steps_data = response.application.steps_data
      setApplicationData(steps_data)

      if (steps_data.entry_level_check__c && isEmpty(response.application.entry_level_check_value__c) && response.application.entry_level_check_value__c !== steps_data.entry_level_check_value__c) {
        setEntryLevel(true)
        entryLevelCheck(steps_data)
      }

      let field = []
      if (steps_data.heroku_role__c === 'Financial Information') {
        field = externalFinancialInformation(steps_data.iteration_data && steps_data.iteration_data.added_questions, steps_data.references)
        setExternalFinancial(field)
        filterConfigFields(field, steps_data.dependent_configs_for_various_steps)
      } else {
        setFieldData(steps_data.fields)
        steps_data.fields.filter(r => {
          if (!r.answer && r.auto_populate_from_config__c) {
            r.answer = autoPopulateAnswersFromConfig(r.auto_populate_from_config__c, steps_data.auto_populate_from_config_answers, '')
          }
        })
        let stepsData = steps_data
        updateRollUpConfig(stepsData)
        updateFormulaFieldAnswer(stepsData.fields, response.application.dependent_configs || [])
        filterConfigFields(stepsData.fields, stepsData.dependent_configs_for_various_steps)

        setRecommenderButton(recommenderSkip(stepsData, stepsData.fields))
      }
      setRecommenderField(steps_data.references || [])
      setIterationData(steps_data.iteration_data)
      setIterationField(steps_data.iteration_data && steps_data.iteration_data.new_questions)
      setIsCompleted(steps_data.order__c == response.scholarship.total_steps)
      setPrimaryColour(response?.scholarship?.primary_branding_color__c ||response?.account?.primary_color__c ||  primaryColor)
      setFirstTimeSubmit(false)
      setLoading(false);
      onCallBack() 
      dispatch(setMateTagTitle({ title: response.scholarship.name, description: response.scholarship.description__c }))
    } else {
      setLoading(false);
    }
  }

  const onCloseCheck = () => {
    setModalState({
      visible: false,
      id: 'recommender__create',
      class: 'application_step_modal',
      content: ''
    });
  }

  const alertShow = (fun, type) => {
    setUpdateAlert(fun)
    onCloseCheck()
    if (type === 'entryLevel') {
      setEntryLevel(false)
    }
  }

  const entryLevelCheck = (steps_data) => {
    setModalState({
      visible: true,
      id: 'recommender__create',
      class: 'application_step_modal',
      content: <EnterLevelModal
        title={steps_data.renewal_popup_title__c || "Please enter the access code."}
        handleClose={onCloseCheck}
        alertShow={alertShow}
        applicationData={steps_data}
        setUpdateAlert={setUpdateAlert}
        setLoading={setLoading}
        redirectURL={applicationId ? `/application/${scholarshipid}/${applicationId}` : `/scholarships/${scholarshipid}`}
      />
    });
  }

  /**
   * Handle modal field value change.
   */
  const filterConfigFields = (data, dependent_configs_for_various_steps) => {
    let skipConfigIdField = skipConfigIds(data, dependent_configs_for_various_steps)
    let skipConfigValueField = skipConfigValue(skipConfigIdField, dependent_configs_for_various_steps)
    skipConfigValueField.filter(question => {
      question.answer = (['Date(Date-Month-Year)', 'Date', 'Date(Month-Date-Year)'].includes(question.data_type__c)) ? (question.answer || question.default_day_for_date__c) : question.answer || ''
    })

    // const filteredQuestions = skipConfigValueField.filter(a => (a.hide_config_for_roles__c || '').split(';').map(a => a.toLowerCase()).indexOf(userContext ? userContext.toLowerCase() : userContext) < 0)
    const filteredQuestions = hideQuestionFiltered(skipConfigValueField, userContext)

    setFilterFieldData(filteredQuestions)
  }


  // TODO: Validate, save, submit application.
  const handleGoToPrevious=()=>{
    setLoading(true);
    setFirstTimeSubmit(false)
    router.push(router.query.previous||'/')
    setFilterFieldData([])
    setErrors([])
    window.scrollTo(0, 0)
    setIterationData({})
    setIterationField([])
    setEmailConfimation('')
  }
  const handlePrevious = () => {
    let isRediractLocal = localStorage.getItem("isRedireactSave") ? JSON.parse(localStorage.getItem("isRedireactSave")) : false
    if(isRediractLocal){
      const getAlert = () => (
        <>
          <div className="save-changes-confirmation-alert modal-utility">
            <SweetAlert
              showConfirm={true}
              confirmBtnText="Okay"
              showCancel={true}
              cancelBtnText="Cancel"
              customButtons={
                <div className='action-footer'>
                  <button onClick={(e) => setIsOpenSweetAlert(false)} className='cta-button CTABlack cta-button__text'>Cancel</button>
                  <button onClick={(e) => { setIsOpenSweetAlert(false), gotoPrevious(), localStorage.setItem("isRedireactSave", false) }} className='cta-button CTAWhite tertiary cta-button__text'>Ok</button>
                </div>
              }
              className=""
            >
              <div style={{ display: 'flex' }}>
                <div>
                  <Alert />
                </div>
                <div className='content'>
                  <p className='title'>Are you sure you want to exit?</p>
                  <p className="CTAGrey">All changes will be lost if you leave this page without saving.</p>
                </div>
              </div>
            </SweetAlert>
          </div>
        </>
      );
      setIsOpenSweetAlert(getAlert)
    }
    else{
    gotoPrevious()
    }
  }
  const gotoPrevious=()=>{
    setLoading(true);
    setFirstTimeSubmit(false)
    router.push(`/apply/${scholarshipid}/${application.prev_step_id}/${application.heroku_id__c}`, undefined, { shallow: true })
    setFilterFieldData([])
    setErrors([])
    window.scrollTo(0, 0)
    setIterationData({})
    setIterationField([])
    setEmailConfimation('')
    if(!isMobileScreen){
      customScroll.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
  const handlejumpto = (e, stepID) => {
    e.preventDefault();
    // let isRediractLocal = localStorage.getItem("isRedireactSave") ? JSON.parse(localStorage.getItem("isRedireactSave")) : false
    // if(isRediractLocal)
    // setLoading(true);
    // setFirstTimeSubmit(false)
    // // router.push(`/apply/${scholarshipid}/${stepID}/${application.heroku_id__c}`, undefined, { shallow: true })
    // setFilterFieldData([])
    // setErrors([])
    // window.scrollTo(0, 0)
    // setIterationData({})
    // setIterationField([])
    // setEmailConfimation('')
    if (router?.query?.applicationstepid !== stepID) {
      setIterationData({})
      setIterationField([])
      // setFilterFieldData([])
      setEmailConfimation('')
      setErrors([])
      setLoading(true)
    }
    handleClickViewAllStep(`/apply/${scholarshipid}/${stepID}/${application.heroku_id__c}`)

    if(!isMobileScreen){
      customScroll.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
    window.scrollTo(0, 0)
  }
  const changeRoute = (url) => {
    router.push(url, undefined, { shallow: true })
    // setLoading(false)

  }

  const removeQuestions = (data) => {
    return data.filter(question => {
      const salesforceFieldValue = question.salesforce_field_value__c?.toLowerCase()

      // remove the encrypted question
      if(question.encryptable__c && question.is_encrypted){
      // Keep the question in the array if any of the conditions are not matched
        return !(question.encryptable__c && question.answer && question.is_encrypted)
      }
      if (
        isValidDateOfBirth(question.answer) &&
        salesforceFieldValue?.includes("application__c.date_of_birth__c") &&
        question.answer
      ) {
        return false;
      }
    // remove question if more than 255 characters are entered.
      if(isTextInputHaveMaxValue(question)) {
        return false;
      }
      //  remove the hidden field type question 
      const isFieldTypeField = question.config_type__c === "Field";
      const isAnswerNull = question.answer === null;
      // Keep the question in the array if any of the conditions are not matched
      return !(isFieldTypeField && isAnswerNull);
    });
  }

  // TODO: Validate,
  
  const validationCheck = (data, buttonName, showFlashmessage = '',callback=()=>{}, documentAction='') => {
    let errorArg = []
    let errorArsForSave=[]
    if (scholarship.status__c === 'Closed' && scholarship.allow_applicant_uploads_after_deadline__c) {
      return true
    }
    const handleMaxCharValidation = (row) => {
      if(isTextInputHaveMaxValue(row)) {
        errorArg.push({
          id: row.id,
          message: 'Please enter value equal or less than 255 characters.'
        })
      }
    }
    if (buttonName == 'next') {
      // If any answer is not in the answer_options__c array, show validation error
      data.map((row) => {
        if (row.required__c && row.config_type__c === "Field" && row.salesforce_field_value__c && validateSelectTypeFields.includes(row.data_type__c) && row.answer_options__c && !row.answer_options__c?.split(';').includes(row.answer)) {
          if (row.data_type__c == 'Multiselect Picklist') {
            const answers = row.answer || []
            // Check each answer against the answer_options__c array
            const isAnswerInclude = (answer) => row.answer_options__c?.split(';').includes(answer.toString())
            const isValid = typeof answers == 'string' ? isAnswerInclude(answers) : answers?.every(answer =>
              isAnswerInclude(answer)
            );
            if (!isValid) {
              errorArg.push({
                id: row.id,
                message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
              });
            }
          } else {
            errorArg.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
        }
        handleMaxCharValidation(row)
      })
    }
    
    const checkValidationForSave = () => {
      const dependentConfigs = (application.dependent_configs || [])
      let error = false
      data.map((row) => {
        if (dateDataType.indexOf(row.data_type__c) > -1 && row.answer) {
          if (!checkDateFormats(row.answer, row.data_type__c)) {
            errorArsForSave.push({
              id: row.id,
              message: 'Please enter a valid date.'
            })
          }
        }

        if (
          row.salesforce_field_value__c &&
          row.salesforce_field_value__c.includes(
            "Application__c.Date_of_Birth__c"
          ) &&
          row.answer
        ) {
          if (isValidDateOfBirth(row.answer)) {
            errorArsForSave.push({
              id: row.id,
              message: isValidDateOfBirth(row.answer)
            })
          }
        }

        if (row.required__c && !row.answer && row.config_type__c !== "Docusign" && row.answer != false && !allDocType.includes(row.data_type__c)) {
          errorArsForSave.push({
            id: row.id,
            message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
          })
        }
        if (row.required__c && row.answer == "false" && row.data_type__c == "Agreement PopUp") {
          errorArsForSave.push({
            id: row.id,
            message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
          })
        }

        if (!row.exit_config__c && row.answer && (row.max_date__c && row.min_date__c)) {
          var currentDate = new Date(row.answer).setHours(0, 0, 0, 0);

          var minDate = new Date(row.min_date__c).setHours(0, 0, 0, 0);
          var maxDate = new Date(row.max_date__c).setHours(0, 0, 0, 0);
          var finalDate = currentDate >= minDate && currentDate <= maxDate;
          if (!finalDate) {
            errorArsForSave.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : "Please Enter valid date!"
            })
          }
        }

        if (row.answer && row.data_type__c == "Email") {
          var emailValidError = validateEmailRegex(row.answer)
            ? ""
            : "Email is not valid!";
          if (emailValidError) {
            errorArsForSave.push({
              id: row.id,
              message: emailValidError
            })
          } else {
            var temp = errorsForSave.filter(obj => obj.id != row.id)
            setErrorsForSave(temp)
          }

        }
        if (row.required__c && !row.answer && row.auto_suggest__c) {
          errorArsForSave.push({
            id: row.id,
            message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
          })
        }
        if (row.required__c && !row.answer && row.config_type__c !== "Message" && !allDocType.includes(row.data_type__c)) {
          errorArsForSave.push({
            id: row.id,
            message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
          })
        }
        if (row.data_type__c === 'Number' && row.answer && (row.max_value__c || row.min_value__c)) {
          if (row.min_value__c && (row.answer < row.min_value__c)) {
            
            errorArsForSave.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
          if ((row.max_value__c && (row.answer > row.max_value__c))) {
            
            errorArsForSave.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
        }

        if ((row.data_type__c === 'Currency') && row.answer && (row.max_value__c || row.min_value__c)) {
          let num = row.answer;
          if (typeof num === 'string') {
              num = parseInt(num.replace(/,/g, '') || 0);
          }
          if (row.min_value__c && (num < row.min_value__c)) {
            
            errorArsForSave.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
          else if ((row.max_value__c && (num > row.max_value__c))) {
            
            errorArsForSave.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
        }

        if (dataTypeJoin.includes(row.data_type__c) && row.answer?.length > 0 && (row.max_value__c || row.min_value__c)) {
          if (row.min_value__c && (row.answer?.length < row.min_value__c)) {
            
            errorArsForSave.push({
              id: row.id,
              message: `Please select atleast ${row.min_value__c} options.` || MAIN_CONFIG.DEFAULT_ERROR
            })
          }
          if ((row.max_value__c && (row.answer?.length > row.max_value__c))) {
            
            errorArsForSave.push({
              id: row.id,
              message: `You can select ${row.max_value__c} options only.` || MAIN_CONFIG.DEFAULT_ERROR
              // message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
        }

        if (row.answer && (row.number_input_required_max_length__c || row.number_input_required_min_length__c)) {
          if (row.number_input_required_min_length__c && (row.answer?.length < row.number_input_required_min_length__c)) {
            
            errorArsForSave.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
          if ((row.number_input_required_max_length__c && (row.answer?.length > row.number_input_required_max_length__c))) {
            
            errorArsForSave.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
        }

        // Check for Minimum document Upload
        if ((row.document || []).length < row.minimum_doc_upload_required__c) {
          // toast.error(<FlashMessage message={row.minimum_doc_error_message__c || MAIN_CONFIG.DEFAULT_ERROR} />)
          errorArsForSave.push({
            id: row.id,
            message: row.error_message__c ? row.error_message__c : row.minimum_doc_error_message__c ? row.minimum_doc_error_message__c : MAIN_CONFIG.DEFAULT_ERROR
          })
        }
        
        if ((row.required__c && allDocType.includes(row.data_type__c)) || row.doc_upload_required__c) {
          if ((isEmpty(row.document) || isEmpty(row.document.url)) && (row.document || []).length < 1) {
            errorArsForSave.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
        }

        if ((row.data_type__c === 'Long Text') && row.word_count_enable__c) {
          const minWords = row.minimum_word_required__c || 0
          var words;
          words = ((row.answer || "").match(/\S+/g) || []).length || 0;
          if (words < minWords) {
            // errors[row.name] = `Please enter minimum ${minWords} words.`
            errorArsForSave.push({
              id: row.id,
              message: `Please enter minimum ${minWords} words.`
              // message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          } else {
            var tempErr = errorsForSave.filter(obj => obj.id != row.id)
            setErrorsForSave(tempErr)
          }
        }

        if (row.config_type__c === "Field" && row.data_type__c === 'Email' && (row.salesforce_field_value__c.includes("Application__c.Email_Address__c") && scholarship.form_type__c !== "Donation Form")) {
          if (!accountData.token && emailConfimation === '' || emailConfimationErrors !== '') {
            error = true
            // setEmailConfimationErrors("Please confirm your email address.")
          } else {
            error = false
          }
        }

        if (row.exit_config_name__c && row.answer) {
          const operator = row.exit_operator__c
          const totalInputs = (data.concat(dependentConfigs))
          const parentConfig = totalInputs.find(obj => { return (obj.name === row.exit_config_name__c) })
          let Errored = false
          if (parentConfig) {
            var numberPattern = /\d+/g;
            const formattedInputAnswer = ((row.answer || "0").toString().match(numberPattern) || []).join('')
            const formattedParentAnswer = ((parentConfig.answer || "0").toString().match(numberPattern) || []).join('')
            switch (operator) {
              case 'Less': {
                // eslint-disable-next-line
                Errored = !(parseFloat(formattedInputAnswer) >= parseFloat(formattedParentAnswer, 10))
                break;
              }
              case 'Greater':
                // eslint-disable-next-line
                Errored = !(parseFloat(formattedInputAnswer, 10) <= parseFloat(formattedParentAnswer, 10))
                break;
              case 'equals':
                Errored = !(row.answer === parentConfig.answer)
                break;
              case 'contains':
                Errored = !(row.answer.includes(parentConfig.answer))
                break;
              default:
                Errored = false;
            }
          }
          if (Errored) {
            errorArsForSave.push({
              id: row.id,
              message: row.error_message__c || 'Please enter valid answer.'
            })

          }
        }

        if (row.required_when__c && checkRequiredWhen(row)) {
          const parent = data.concat(applicationData.dependent_configs_for_various_steps).find(obj => (obj.label__c && (obj.label__c.toString() === row.config_name__c)))
          const configValues = (row.config_value__c || '').split(';')
          if (parent) {
            if ((row.operator__c === 'contains') && containsVal(parent.answer, configValues)) {
              errorArsForSave.push({
                id: row.id,
                message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
              })
            } else if ((row.operator__c === 'equals') && hasEqualVal(parent, configValues)) {
              errorArsForSave.push({
                id: row.id,
                message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
              })
            }
          }
        }

      })


      if (!isEmpty(errorArsForSave) || error) {
        setErrorsForSave(errorArsForSave)
        return false
      } else {
        return true
      }
    }
    if (buttonName === 'save') {
      data.map((row) => {
        if (row.answer && row.data_type__c == "Email") {
          let emailValidError = validateEmailRegex(row.answer)
            ? ""
            : "Email is not valid";
          if (emailValidError) {
            errorArg.push({
              id: row.id,
              message: emailValidError
            })
          } else {
            let temp = errors.filter(obj => obj.id != row.id)
            setErrors(temp)
          }
        }
        handleMaxCharValidation(row)
      })
      data.filter(a => dateDataType.indexOf(a.data_type__c) > -1).map(row => {
        if (dateDataType.indexOf(row.data_type__c) > -1 && row.answer) {
          if (!checkDateFormats(row.answer, row.data_type__c)) {
            errorArg.push({
              id: row.id,
              message: 'Please enter a valid date.'
            })
          }
        }
        if (
          row.salesforce_field_value__c &&
          row.salesforce_field_value__c.includes(
            "Application__c.Date_of_Birth__c"
          ) && row.answer
        ) {
          if (isValidDateOfBirth(row.answer)) {
            errorArg.push({
              id: row.id,
              message: isValidDateOfBirth(row.answer)
            })
          }
        }
        if (!row.exit_config__c && row.answer && (row.max_date__c && row.min_date__c)) {
          var currentDate = new Date(row.answer).setHours(0, 0, 0, 0);
          var minDate = new Date(row.min_date__c).setHours(0, 0, 0, 0);
          var maxDate = new Date(row.max_date__c).setHours(0, 0, 0, 0);
          var finalDate = currentDate >= minDate && currentDate <= maxDate;
          if (!finalDate) {
            errorArg.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : "Please Enter valid date!"
            })
          }
        }
      })
      if (errorArg?.length > 0) {
        setErrors(errorArg)
        callback (false)
        return false
        // return errorArg.length > 0
      } else {
        setErrors([])
        callback (!checkValidationForSave())
      return true
      }
    }
      const dependentConfigs = (application.dependent_configs || [])
      let error = false
      data.map((row) => {
        if (dateDataType.indexOf(row.data_type__c) > -1 && row.answer) {
          if (!checkDateFormats(row.answer, row.data_type__c)) {
            errorArg.push({
              id: row.id,
              message: 'Please enter a valid date.'
            })
          }
        }

        if (
          row.salesforce_field_value__c &&
          row.salesforce_field_value__c.includes(
            "Application__c.Date_of_Birth__c"
          ) && row.answer
        ) {
          if (isValidDateOfBirth(row.answer)) {
            errorArg.push({
              id: row.id,
              message: isValidDateOfBirth(row.answer)
            })
          }
        }

        if (row.required__c && !row.answer && row.config_type__c !== "Docusign" && row.answer != false && !allDocType.includes(row.data_type__c)) {
          errorArg.push({
            id: row.id,
            message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
          })
        }
        if (row.required__c && row.answer == "false" && row.data_type__c == "Agreement PopUp") {
          errorArg.push({
            id: row.id,
            message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
          })
        }

        if (!row.exit_config__c && row.answer && (row.max_date__c && row.min_date__c)) {
          var currentDate = new Date(row.answer).setHours(0, 0, 0, 0);

          var minDate = new Date(row.min_date__c).setHours(0, 0, 0, 0);
          var maxDate = new Date(row.max_date__c).setHours(0, 0, 0, 0);
          var finalDate = currentDate >= minDate && currentDate <= maxDate;
          if (!finalDate) {
            errorArg.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : "Please Enter valid date!"
            })
          }
        }

        if (row.answer && row.data_type__c == "Email") {
          var emailValidError = validateEmailRegex(row.answer)
            ? ""
            : "Email is not valid!";
          if (emailValidError) {
            errorArg.push({
              id: row.id,
              message: emailValidError
            })
          } else {
            var temp = errors.filter(obj => obj.id != row.id)
            setErrors(temp)
          }

        }
        if (row.required__c && !row.answer && row.auto_suggest__c) {
          errorArg.push({
            id: row.id,
            message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
          })
        }
        if (row.required__c && !row.answer && row.config_type__c !== "Message" && !allDocType.includes(row.data_type__c)) {
          errorArg.push({
            id: row.id,
            message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
          })
        }
        if (row.data_type__c === 'Number' && row.answer && (row.max_value__c || row.min_value__c)) {
          if (row.min_value__c && (row.answer < row.min_value__c)) {
            if (showFlashmessage) {
              toast.error(<FlashMessage type='error' message={`Please enter number equal or greater than ${row.min_value__c}.`} />)
            }
            errorArg.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
          if ((row.max_value__c && (row.answer > row.max_value__c))) {
            if (showFlashmessage) {
              toast.error(<FlashMessage type='error' message={`Please enter number equal or less than ${row.max_value__c}.`} />)
            }
            errorArg.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
        }

        if ((row.data_type__c === 'Currency') && row.answer && (row.max_value__c || row.min_value__c)) {
          let num = row.answer;
          if (typeof num === 'string') {
              num = parseInt(num.replace(/,/g, '') || 0)
          }
          if (row.min_value__c && (num < row.min_value__c)) {
            if (showFlashmessage) {
              toast.error(<FlashMessage type='error' message={`Please enter value equal or greater than $${row.min_value__c}.`} />)
            }
            errorArg.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
          else if ((row.max_value__c && (num > row.max_value__c))) {
            if (showFlashmessage) {
              toast.error(<FlashMessage type='error' message={`Please enter value equal or less than $${row.max_value__c}.`} />)
            }
            errorArg.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
        }

        if (dataTypeJoin.includes(row.data_type__c) && row.answer?.length > 0 && (row.max_value__c || row.min_value__c)) {
          if (row.min_value__c && (row.answer?.length < row.min_value__c)) {
            if (showFlashmessage) {
              toast.error(<FlashMessage type='error' message={`Please select atleast ${row.min_value__c} options.`} />)
            }
            errorArg.push({
              id: row.id,
              message: `Please select atleast ${row.min_value__c} options.` || MAIN_CONFIG.DEFAULT_ERROR
            })
          }
          if ((row.max_value__c && (row.answer?.length > row.max_value__c))) {
            if (showFlashmessage) {
              toast.error(<FlashMessage type='error' message={`You can select ${row.max_value__c} options only.`} />)
            }
            errorArg.push({
              id: row.id,
              message: `You can select ${row.max_value__c} options only.` || MAIN_CONFIG.DEFAULT_ERROR
              // message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
        }

        if (row.answer && (row.number_input_required_max_length__c || row.number_input_required_min_length__c)) {
          if (row.number_input_required_min_length__c && (row.answer?.length < row.number_input_required_min_length__c)) {
            if (showFlashmessage) {
              toast.error(<FlashMessage type='error' message={`Please enter at least ${row.number_input_required_min_length__c} characters.`} />)
            }
            errorArg.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
          if ((row.number_input_required_max_length__c && (row.answer?.length > row.number_input_required_max_length__c))) {
            if (showFlashmessage) {
              toast.error(<FlashMessage type='error' message={`Please enter ${row.number_input_required_max_length__c} characters only.`} />)
            }
            errorArg.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
        }

        // Check for Minimum document Upload
        if ((row.document || []).length < row.minimum_doc_upload_required__c) {
          errorArg.push({
            id: row.id,
            message: row.error_message__c ? row.error_message__c : row.minimum_doc_error_message__c ? row.minimum_doc_error_message__c : MAIN_CONFIG.DEFAULT_ERROR
          })
        }

        if ((row.required__c && allDocType.includes(row.data_type__c)) || row.doc_upload_required__c) {
          if ((isEmpty(row.document) || isEmpty(row.document.url)) && (row.document || []).length < 1) {
            errorArg.push({
              id: row.id,
              message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          }
        }

        if ((row.data_type__c === 'Long Text') && row.word_count_enable__c) {
          const minWords = row.minimum_word_required__c || 0
          var words;
          words = ((row.answer || "").match(/\S+/g) || []).length || 0;
          if (words < minWords) {
            // errors[row.name] = `Please enter minimum ${minWords} words.`
            errorArg.push({
              id: row.id,
              message: `Please enter minimum ${minWords} words.`
              // message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
            })
          } else {
            var tempErr = errors.filter(obj => obj.id != row.id)
            setErrors(tempErr)
          }
        }

        if (row.config_type__c === "Field" && row.data_type__c === 'Email' && (row.salesforce_field_value__c.includes("Application__c.Email_Address__c") && scholarship.form_type__c !== "Donation Form")) {
          if (!accountData.token && emailConfimation === '' || emailConfimationErrors !== '') {
            error = true
            setEmailConfimationErrors("Please confirm your email address.")
          } else {
            error = false
          }
        }

        if (row.exit_config_name__c && row.answer) {
          const operator = row.exit_operator__c
          const totalInputs = (data.concat(dependentConfigs))
          const parentConfig = totalInputs.find(obj => { return (obj.name === row.exit_config_name__c) })
          let Errored = false
          if (parentConfig) {
            var numberPattern = /\d+/g;
            const formattedInputAnswer = ((row.answer || "0").toString().match(numberPattern) || []).join('')
            const formattedParentAnswer = ((parentConfig.answer || "0").toString().match(numberPattern) || []).join('')
            switch (operator) {
              case 'Less': {
                // eslint-disable-next-line
                Errored = !(parseFloat(formattedInputAnswer) >= parseFloat(formattedParentAnswer, 10))
                break;
              }
              case 'Greater':
                // eslint-disable-next-line
                Errored = !(parseFloat(formattedInputAnswer, 10) <= parseFloat(formattedParentAnswer, 10))
                break;
              case 'equals':
                Errored = !(row.answer === parentConfig.answer)
                break;
              case 'contains':
                Errored = !(row.answer.includes(parentConfig.answer))
                break;
              default:
                Errored = false;
            }
          }
          if (Errored) {
            errorArg.push({
              id: row.id,
              message: row.error_message__c || 'Please enter valid answer.'
            })

          }
        }

        if (row.required_when__c && checkRequiredWhen(row)) {
          const parent = data.concat(applicationData.dependent_configs_for_various_steps).find(obj => (obj.label__c && (obj.label__c.toString() === row.config_name__c)))
          const configValues = (row.config_value__c || '').split(';')
          if (parent) {
            if ((row.operator__c === 'contains') && containsVal(parent.answer, configValues)) {
              errorArg.push({
                id: row.id,
                message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
              })
            } else if ((row.operator__c === 'equals') && hasEqualVal(parent, configValues)) {
              errorArg.push({
                id: row.id,
                message: row.error_message__c ? row.error_message__c : MAIN_CONFIG.DEFAULT_ERROR
              })
            }
          }
        }

      })


      if (!isEmpty(errorArg) || error) {
        setErrors(errorArg)
        return false
      } else {

        return true
      }
  
  }

  const onClose = () => {
    setLoading(true)
    window.location.href = checkMarketPlace()
    setUpdateAlert(false)
  }

  const handleParentConsent = async (applicantName, guardianEmail) => {
    const response = await API.parentalConsentRequest({ applicant_name: applicantName, guardian_email: guardianEmail, scholarshipId: scholarshipid });
    if (response.success) {
      toast.success(<FlashMessage message={response.message} />);
      setTimeout(() => {
        router.push("/", undefined, { shallow: true })
      }, 5000);
    } else {
      toast.error(<FlashMessage type={'error'} message={response.message} />);
      setLoading(false)
      return false
    }
  }

  // TODO:  save, submit application.
  const handleSubmit = async (event, buttonName) => {
    event.preventDefault()
    var getData = filterFieldData.find(record => record.data_type__c == "Email")
    if (isOpenLoginPassword) {

      setModalState({
        visible: true,
        id: 'enter-password-modal__create',
        class: 'application_step_modal',
        content: <EnterPasswordModal
          email={getData.answer}
          handleClose={onCloseCheck}
          handleLogin={handleLogin}
          handleSend={handleSend}
          setLoading={setLoading}
        />
      });
      return false
    }

    setLoading(true);
    setFirstTimeSubmit(false)
    if (buttonName === 'next') {
      setFirstTimeSubmit(true)
    }

    let updatedData = removeQuestions(fieldData);

    let allFields = updatedData.map((row) => {
      // return { sfid: row.sfid, answer: '' }
      return { sfid: row.sfid, answer: row.config_type__c === "Field" ? row.answer : '' }
    })

    let validated = false
    if (validationCheck(filterFieldData, buttonName, "isShowMessage",(newValue) => {
      validated = newValue})) {
      let applicationsData = ''
      if (filterFieldData?.length > 0) {
        filterFieldData.filter((row) => {
          if (row.answer && row.data_type__c === "Currency") {
            row.answer = (row.config_type__c === 'Field') ? row.answer.toString().split(',').join('') : formatCurrency(row.answer, row?.currency_symbol__c || 'USD'); //parseFloat(row.answer.replace(/,/g, ''))
          }
        })
      }
        let data = []
        data = setParamResponse(filterFieldData)
        if (envelopeId) {
          data.docusign_envelope_id = envelopeId
        }
        if (!(scholarship.status__c === 'Closed' && scholarship.allow_applicant_uploads_after_deadline__c) && !recommenderButton && applicationData.minimum_record_required__c && applicationData.minimum_record_required__c > (applicationData.heroku_role__c ? applicationData?.references?.length : iterationData?.added_questions?.length)) {
          toast.error(<FlashMessage type='alert' message={`Please add a minimum of ${applicationData.minimum_record_required__c} records.`} />);
          setLoading(false);
          return false
        }

        if (isOpenPassword) {
          data.push({ answer: password, sfid: "password" })
        }
        data = applicationFormAutoSuggestHiddenConfigs(fieldData, data)

        let allQuestions = mergeArrays(allFields, data)

        applicationsData = { application_data: allQuestions, entry_level_check_value__c: applicationData.entry_level_check_value__c }
      
      var token = ''
      if (!accountData.token) {
        var firstName = ''
        var lastName = ''
        var email = ''
        filterFieldData.map((question) => {
          let check = question.salesforce_field_value__c || ''
          if (check.split(";").some(c => c == 'Application__c.First_Name__c')) {
            firstName = question.answer
          } else if (check.split(";").some(c => c == 'Application__c.Last_Name__c')) {
            lastName = question.answer
          } else if (check.split(";").some(c => c == 'Application__c.Email_Address__c')) {
            email = question.answer
          }
        })

        if (blankSpaceCheck(firstName, lastName)) {
          toast.error(<FlashMessage type={'error'} message="You can't add spaces at the beginning of the first name or last name." />)
          setLoading(false);
          return false;
        } else if (firstName == "" || lastName == "" || email == "") {
          toast.error(<FlashMessage type={'error'} message="First name, last name or email can't be blank." />)
          setLoading(false);
          return false;
        }else if (checkFieldLength(firstName, 40)) {
          toast.error(<FlashMessage type={'error'} message="First name must be less than 40 characters." />);
          setLoading(false);
          return false;
        } else if (checkFieldLength(lastName, 80)) {
          toast.error(<FlashMessage type={'error'} message="Last name must be less than 80 characters." />);
          setLoading(false);
          return false;
        }else if (checkFieldLength(email, 80)) {
          toast.error(<FlashMessage type={'error'} message="Email must be less than 80 characters." />);
          setLoading(false);
          return false;  
        }else if (thirteenYearAge) {
          token = await handleSignUp(firstName, lastName, email)
          if (token == false) {
            return false
          }
        }
        else {
          setModalState({
            visible: true,
            id: 'enter-password-modal__create',
            class: 'application_step_modal',
            content: <ParentConsentModal
              handleClose={onCloseCheck}
              handleParentConsent={handleParentConsent}
              setLoading={setLoading}
              applicantEmail={getData?.answer}
            />
          });
          setLoading(false);
          return false
        }
      }

      let stepSubmitedStatus = validated
      var cloneApplicationData = JSON.parse(JSON.stringify(applicationsData))
      cloneApplicationData.submitted_application_step=buttonName==='next'?true:!stepSubmitedStatus
      const response = await API.submitScholarship({ 'token': accountData.token || token, scholarshipId: scholarshipid, applicationStepId: applicationData.sfid, applicationsData:cloneApplicationData, applicationId: applicationId || '' })

      if (!response.success) {
        toast.error(<FlashMessage type='error' message={parseHtml(response.message) || `Something went wrong.`} />);
        setLoading(false);
      } else {
        if (response.application_status === 'Draft' || response.application_status === 'Prototype' || scholarship.allow_edit_after_application_submission__c || scholarship.allow_applicant_uploads_after_deadline__c || scholarship.access_code_to_edit_after_deadline__c) {
          toast.success(<FlashMessage message={`Saved`} />);
          localStorage.setItem("isRedireactSave", false)
          setIsCompleted(response.next_step_id ? true : false)
          setTimeout(()=> {
           if(buttonName === 'save'){
            if (router?.query?.applicationId) {
            fetchSetpsData()
            fetchApplyScholarship()
            }
           }
         })
          const redirectURL = response.next_step_id ? `/apply/${scholarshipid}/${response.next_step_id}/${response.application_id}` : `/application/${scholarshipid}/${response.application_id}?action=submit`;
          if (buttonName === 'next') {
            setFilterFieldData([])
            setErrors([])
            setIterationData({})
            setIterationField([])
            setEmailConfimation('')
            router.push(redirectURL, undefined, { shallow: true })
          } else {
            if (applicationData.order__c === 1) {
              if (!applicationId) {
                let URL = `/apply/${scholarshipid}/${applicationstepid}/${response.application_id}`;
                router.push(URL, undefined, { shallow: true })
              } else {
                setLoading(false);
              }
            } else {
              setLoading(false);
            }
             // Reload the page after click on save
            //  window.location.reload();
    
          }
        } else {
          setLoading(false);
          const getAlert = () => (
            <SweetAlert
              warning
              show={true}
              confirmBtnText="Close"
              confirmBtnBsStyle="danger"
              onConfirm={() => onClose()}
              showConfirm={true}
              title={response.application_status}
              customClass="user-confirmation-alert"
            >
              <p className="user-confirmation-alert__message">{parseHtml(response.exit_reason__c)}</p>
            </SweetAlert>
          );
          setUpdateAlert(getAlert())
          return false
        }
      }
    } else {
      setLoading(false);
    }
    if(!isMobileScreen){
      customScroll.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
    window.scrollTo(0, 0)
  }


  /**Alert Popup When CLick on Cancel */

  const alretMsg = (val = '') => {
    const getAlert = () => (
       <div className="save-changes-confirmation-alert modal-utility iteration-modal-save-changes-alert">
          <SweetAlert
            showConfirm={true}
            confirmBtnText="Okay"
            showCancel={true}
            cancelBtnText="Cancel"
            customButtons={
              <div className='action-footer'>
                <button onClick={(e) => setIsOpenSweetAlert(false)} className='cta-button CTABlack cta-button__text'>Cancel</button>
                <button onClick={(e) => { closeIterationModal() }} className='cta-button CTAWhite tertiary cta-button__text'>Ok</button>
              </div>
            }
            className=""
            
          >
            <div style={{ display: 'flex' }}>
              <div>
                <Alert />
              </div>
              <div className='content'>
                <p className='title'>Are you sure you want to exit?</p>
                <p className="CTAGrey">Any progress for your entry will not be saved until you hit “Submit”.</p>
              </div>
            </div>
          </SweetAlert>
        </div>
    );
    setIsOpenSweetAlert(getAlert)
  }

  const handleSignUp = async (firstName, lastName, email) => {
    let user = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      password: password,
      cell_phone: '',
      smagicinteract__smsoptout__c: true,
      hasoptedoutofemail: true,
		  promotional_email_opt_out__c: true
  }
    const auth = await API.authenticateSignUpOnboarding(user);
    if (auth.user) {
      document.cookie = `token=${auth.user.token};path=/`;
      document.cookie = `context=APPLICANT;path=/`;
      // getAllInstitutionList("", auth.user.token)
      toast.success(<FlashMessage message={'User registered'} />);
      return auth.user.token
    } else {
      // TODO: Handle error here
      toast.error(<FlashMessage type={'error'} message={auth.message} />);
      setLoading(false)
      return false
    }

  }
  const renderFormattedSections = (activeApplication) => {

    const steps = Object.values(activeApplication);
    return steps
  }

  /**
    * Handle Application answer value changes
    */
  const onChange = (name, value, videoDuration='') => {
    const isDocument = value?._response?.status===201
    const videodurationInSeconds = handleGetVideoDuresion(videoDuration, value)
    const newState = [...fieldData];
    const cloneDoc = cloneDeep(filterFieldData)?.find(val => val.id === name)
    let index = newState.findIndex(item => item.id === name);
    let question = newState.find(record => record.id === name)

    if (isOpenLoginPassword && question.data_type__c != "Email") {
      let getData = newState.find(record => record.data_type__c == "Email")
      setModalState({
        visible: true,
        id: 'enter-password-modal__create',
        class: 'application_step_modal',
        content: <EnterPasswordModal
          email={getData.answer}
          handleClose={onCloseCheck}
          handleLogin={handleLogin}
          handleSend={handleSend}
          setLoading={setLoading}
        />
      });
      return false
    }

    question = onChangeAnswer(question, value, isDocument, false, videodurationInSeconds)
    let childPicklist = newState.filter(obj => obj.parent_picklist_config__c === question.sfid.toString())
    
    const duplicates = newState.filter(
      (record) => {
        if(record.salesforce_field_value__c !== null && record.config_type__c === "Field") {
         return record.salesforce_field_value__c === question.salesforce_field_value__c
        }
      }
    );
    
    if (duplicates.length > 1) {
      duplicates.forEach((duplicateQuestion) => {
        // Update the answer of all the duplicate field type questions to match the current question's answer
        duplicateQuestion.answer = question.answer;
      });
    }

    if (childPicklist?.length > 0) {
      childPicklist.forEach(child => {
        child.answer = ''; // Reset the answer field
      });
    }
    newState[index] = question

    let dependentChild = (question.skip_config_ids__c) ? question.skip_config_ids__c.split(';') : [question.skip_config_ids__c]

    newState.filter(childAnswerReset => {
      if (
        childAnswerReset.answer &&
        childAnswerReset.config_type__c === "Field" &&
        dateDataType.includes(childAnswerReset.data_type__c) &&
        dependentChild.includes(childAnswerReset.name) &&
        isValidDateOfBirth(childAnswerReset.answer)
      ) {
        childAnswerReset.answer = "";
      }
      if (dependentChild.includes(childAnswerReset.name) && childAnswerReset.config_type__c === "Question") {
        childAnswerReset.answer = ''
      }
    })

    updateFormulaFieldAnswer(newState, application.dependent_configs || [])
    setFieldData(newState);
    filterConfigFields(newState, applicationData.dependent_configs_for_various_steps)
    setRecommenderButton(recommenderSkip(applicationData, newState))
    localStorage.setItem("isRedireactSave", true)
    // var temp = errors.filter(obj => obj.id != question.id)
    var temp = (!question.answer) ? [...errors] : errors.filter(obj => (obj.id != question.id))
    if ((question.data_type__c === 'Long Text') && question.word_count_enable__c) {
      validationCheck([question], 'next')
    } else if (isTextInputHaveMaxValue(question)) {
      setErrors([...temp, { id: question.id, message: 'Please enter value equal or less than 255 characters' }]);
    } else {
      validationCheck([question], 'next')
      setErrors([...temp])
    }

    // check Date validation
    handleDateValidate(question, temp)

    // call this function if isDocuemnt is true
    documentsubmit(isDocument, question, cloneDoc)
  }

  const documentsubmit = (isDocument, question, cloneDoc) => {
    if (isDocument) {
    setLoading(true);
    handleDocumentSubmit(question.id, cloneDoc)
    }
  }

  const handleClearEncryptedValue = (e, questionId) => {
    const newState = Array.isArray(fieldData) ? [...fieldData] : [];

    newState.forEach(childAnswerReset => {
      if (childAnswerReset.encryptable__c && childAnswerReset.id === questionId) {
        childAnswerReset.answer = '';
        childAnswerReset.is_encrypted = false;
      }
    });
    setFieldData(newState);
    filterConfigFields(newState, applicationData.dependent_configs_for_various_steps);
  }

  const handleDateValidate = (question, temp) => {
    if (dateDataType.indexOf(question.data_type__c) > -1 && question.answer) {
      if (!checkDateFormats(question.answer, question.data_type__c)) {
        setErrors([...temp, { id: question.id, message: question?.error_message__c ? question.error_message__c : 'Please enter a valid date!' }]);
      }
    }
  }

  const handleGetVideoDuresion = (videoDuration, value) => {
    if (videoDuration) {
      return videoDuration
    } else if (value) {
      return value?._response?.video_duration__c
    } else {
      return ''
    }
  }

  /**
    * Handle Blur Application answer value changes for email
    */
  const onBlur = async (name, value) => {

    const newState = [...fieldData];
    let index = newState.findIndex(item => item.id === name);
    let question = newState.find(record => record.id === name)

    if (validateEmailRegex(value)) {
      const response = await API.checkExistingUser(value);
      if (response?.sso_accounts) {
        setModalState({
          visible: true,
          id: 'enter-password-modal__create',
          class: 'application_step_modal',
          content: <EnterPasswordModal
            email={value}
            handleClose={onCloseCheck}
            handleLogin={handleLogin}
            handleSend={handleSend}
            setLoading={setLoading}
            showSSoButton={response?.sso_accounts?.length > 0 ? true : false}
            ssoAccounts={response?.sso_accounts}
            setModalState={setModalState}
            onCloseCheck={onCloseCheck}
          />
        });
        setIsOpenPassword(false)
        setIsOpenLoginPassword(true)
      } else {
        setIsOpenPassword(true)
        setIsOpenLoginPassword(false)
        // setFilterFieldData(filterFieldData)
      }

    } else {
      toast.error(<FlashMessage type='error' message={"Please enter valid email address"} />);
    }
  }

  const handleSend = async (email) => {
    setLoading(true)
    const response = await API.sendPasswordLink({ token: "", email: { "email": email } })
    if (response.success) {
      toast.success(<FlashMessage message={response.message} />);
      onCloseCheck()
      setLoading(false)
    } else {
      toast.error(<FlashMessage type='error' message={response.message} />);
      setLoading(false)
    }

  }

  const checkPasswordStrenght = (value) => {
    const hasNumber = /\d/.test(value);
    const hasLength = value?.length >= 10
    const hasLowerCase = /[a-z]/.test(value);
    const hasUpperCase = (/[A-Z]/.test(value));
    const hasSymbol = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value);
    setState(prevState => {
      return {
        ...prevState,
        hasNumber: hasNumber,
        hasLength: hasLength,
        hasUpperCase: hasUpperCase,
        hasLowerCase: hasLowerCase,
        hasSymbol: hasSymbol
      }
    })

  }

  const handleSetPassword = (value) => {
    checkPasswordStrenght(value || "")
    setPassword(value)
  }

  //Login
  const handleLogin = async (email, password) => {
    setLoading(true)

    const auth = await API.authenticate(email, password, true);
    if (auth.error) {
      // TODO: Handle error here
      toast.error(<FlashMessage type={'error'} message={auth.error.user_authentication} />);
      setLoading(false)
    } else {
      // Determine the user role context
      document.cookie = `token=${auth.user.token};path=/`;
      document.cookie = `context=APPLICANT;path=/`;
      onCloseCheck()

      let scholarshipDetail = await API.fetchScholarshipById({ token: auth.user.token, scholarshipId: scholarshipid });
      if (scholarshipDetail) {
        setLoading(false)
        if (scholarshipDetail.scholarship.allow_multiple_applications__c && scholarshipDetail.applied_applications && scholarshipDetail.applied_applications?.length > 0) {
          showModal(scholarshipDetail)
        } else {
          if (scholarshipDetail.applied_applications && scholarshipDetail.applied_applications?.length > 0) {
            // setLoading(true)
            let URL = `/application/${scholarshipDetail.scholarship.sfid || scholarshipDetail.scholarship.heroku_id__c}/${scholarshipDetail.applied_applications[0].sfid || scholarshipDetail.applied_applications[0].heroku_id__c}`
            if (scholarshipDetail.applied_applications[0].status__c === 'Submitted' || scholarshipDetail.applied_applications[0].status__c === 'In Review Board') {
              URL = `/application/${scholarshipDetail.scholarship.sfid || scholarshipDetail.scholarship.heroku_id__c}/${scholarshipDetail.applied_applications[0].sfid || scholarshipDetail.applied_applications[0].heroku_id__c}?action=completed`
            }
            router.push(URL, undefined, { shallow: true })
          } else {
            window.location.reload()
          }
        }
        // await fetchApplyScholarship(auth.user.token)      
      }
    }
  }
  /**
   * Adds the modal content and shows the modal.
   */
  const showModal = (scholarshipDetail) => {
    localStorage.setItem('secondaryColor', scholarshipDetail.scholarship.secondary_branding_color__c || scholarshipDetail.account.secondary_color__c || MAIN_CONFIG.COLORS.fillGreen)
    setModalState({
      visible: true,
      className: 'applied-application__List',
      content: <AppliedApplicationList
        handleClose={onClosebutton}
        applicationForm={true}
        appliedApplication={scholarshipDetail.applied_applications}
        scholarshipId={scholarshipDetail.scholarship.sfid}
        scholarship={scholarshipDetail.scholarship}
        setLoading={setLoading}
        applicationStepId={scholarshipDetail.application_step.sfid}
        color={scholarshipDetail.scholarship.primary_branding_color__c || scholarshipDetail.account.primary_color__c}
        secondaryColor={scholarshipDetail.scholarship.secondary_branding_color__c || scholarshipDetail.account.secondary_color__c}
      />
    });
  }
  const onClosebutton = () => {
    setLoading(true)
    setModalState({
      visible: false,
      class: 'applied-application__List',
      content: ''
    });
    router.push("/", undefined, { shallow: true })
  }

  const onQuestionSuggestiveSelect = (name, selectedValue = {}) => {
    let newState = [...fieldData]
    let input = newState.find(input => input.name === name)
    input.answer = selectedValue.name ? selectedValue.name : selectedValue
    newState.map(record => {
      if (record.address_auto_fill_type__c && selectedValue[record.address_auto_fill_type__c]) {
        record.answer = selectedValue[record.address_auto_fill_type__c]
      }
    })
    setFieldData(newState)
    filterConfigFields(newState, applicationData.dependent_configs_for_various_steps)
    var temp = errors.filter(obj => obj.id != input.id)
    setErrors([...temp])
  }

  const onSuggestiveSelect = (data, selectedValue) => {
    let newState = [...fieldData];
    const values = Object.keys(data);
    const selectedInput = newState.find(
      (input) => input?.salesforce_field_value__c?.includes(data)
    );
    if (data['KFC City'] || data['PCUSA Name'] || data['Taco Bell Address 1'] || data['Pizza Hut Address 1'] || data['Financial Aid Office Payee'] || data['ACH Payee']) {
      const types = Object.keys(data);
      types.forEach((type) => {
        let obj = newState.filter(input => ((input.address_auto_fill_type__c === type) || (input.auto_suggest_data__c === type)))

        if (obj.length > 0) {
          obj.forEach(input => {
            input.answer = data[type];
          });
          return null
        }
      })

    } else if (
      data[Object.keys(data)[0]].toLowerCase() === "home schooled" ||
      data[Object.keys(data)[0]].toLowerCase() === "my school not listed"
    ) {
      values.map((value, index) => {
        let inputs = newState.filter(input => {
          let ary = input.salesforce_field_value__c ? input.salesforce_field_value__c.split(';').map(a => a.split('.')) : []
          let merged = [].concat.apply([], ary);
          return merged.indexOf(value) >= 0
        })
        inputs.map((input, index) => {
          if (input && (index > 0)) {
            input['isDependent'] = true
            input.answer = ''
          } else if (input && (index < 1)) {
            input.answer = data[value]
          }
          return null
        })
        return null
      })
    } else if (typeof data === 'object') {
      values.map((value, index) => {
        let inputs = newState.filter(input => {
          let ary = input.salesforce_field_value__c ? input.salesforce_field_value__c.split(';').map(a => a.split('.')) : []
          let merged = [].concat.apply([], ary);
          return merged.indexOf(value) >= 0
        })
        newState.map(input => {
          input['isDependent'] = false
          return null
        })

        inputs.map((input, index) => {
          if (input) {
            input.answer = data[value]
          }
          return null
        })
        return null
      })
    } else if (selectedInput) {
      selectedInput.answer = selectedValue
      let fieldToClear = []
      switch (selectedInput.auto_suggest_data__c) {
        case 'City':
          fieldToClear = newState.filter(input => { return ['Zip'].includes(input.auto_suggest_data__c) })
          break;
        case 'State':
          fieldToClear = newState.filter(input => { return ['Zip', 'City'].includes(input.auto_suggest_data__c) })
          break;
        case 'Country':
          fieldToClear = newState.filter(input => { return ['Zip', 'City', 'State'].includes(input.auto_suggest_data__c) })
          break;
        default:
          fieldToClear = []
      }
      fieldToClear.map(field => {
        field.answer = '';
        return null
      })
    }
    var tempNewState = newState
    var tempArrErr = errors;
    tempNewState.map((item, i) => {
      if (item.answer) {
        if (tempArrErr?.length > 0) {
          tempArrErr = tempArrErr.filter(obj => obj.id != item.id)
        }
      }
    })
    setErrors([...tempArrErr])
    setFieldData(newState)
    filterConfigFields(newState, applicationData.dependent_configs_for_various_steps)
  }

  const handleAddressSelection = async (fieldObj, selectedAddress) => {
    let newAddress={
      city__c: selectedAddress.municipality || '',
      mailing_country__c: selectedAddress.country || '',
      mailing_state_province__c: selectedAddress.countrySubdivisionName || selectedAddress.countrySubdivision || '',
      mailing_zip_postal_code__c: selectedAddress.postalCode || selectedAddress.extendedPostalCode ||  ''
    }
   let address = selectedAddress.freeformAddress ? selectedAddress.freeformAddress.split(',').slice(0, 1).join(' ') : selectedAddress.freeformAddress
    if (selectedAddress.freeformAddress) {
        const fields = Object.keys(newAddress)
        let newState = [...fieldData]
        let addressField = newState.find(input => input.name === fieldObj.name)

        addressField.answer = address
        if (fieldObj.config_type__c === "Field") {
          fields.map(field => {
            let obj = newState.find(input => input.salesforce_field_value__c && (input.salesforce_field_value__c.toLocaleLowerCase().includes(field)))
            if (obj) {
              obj.answer = newAddress[field]
            }
            return null
          })
        }

        if (fieldObj.config_type__c != "Field") {
          newState = addressFieldsautofill(newState, newAddress)
        }
        setFieldData(newState)
        filterConfigFields(newState, applicationData.dependent_configs_for_various_steps)
    }
  }
  const handleDocumentSubmit = async (questionId, doc) => {
    let data = []
    let cloneFilteredData = JSON.parse(JSON.stringify(filterFieldData));
    let updatedData = removeQuestions(filterFieldData);
    updatedData.map((row) => {
      if (row.id === questionId) {
        data.push({ sfid: row.sfid, answer: row.answer, document: row.document })
      } else {
        if (row.answer && (Array.isArray(row.answer) || row.answer.value)) {
          if (row.data_type__c === 'Picklist' || row.data_type__c === "Dependent Picklist") {
            if (Array.isArray(row.answer)) {
              data.push({ sfid: row.sfid, answer: row.answer[0].value })
            } else {
              data.push({ sfid: row.sfid, answer: row.answer.value })
            }
          } else if (dataTypeJoin.includes(row.data_type__c)) {
            data.push({ sfid: row.sfid, answer: row.answer.join(';') })
          }
        } else {
          data.push({ sfid: row.sfid, answer: row.answer || '' })
        }
      }
    })

    if (envelopeId) {
      data.docusign_envelope_id = envelopeId
    }

    data = applicationFormAutoSuggestHiddenConfigs(fieldData, data)
    // let applicationsData = { application_data: data, entry_level_check_value__c: applicationData.entry_level_check_value__c }
    let isOtherFieldsValidated = false
    let iterationCount= iterationData && iterationData.added_questions && iterationData.added_questions?.length + 1
    validationCheck(cloneFilteredData, 'save', '', (newValue) => { isOtherFieldsValidated = newValue })
    let validated = true
    if ((doc.required__c && allDocType.includes(doc.data_type__c)) || doc.doc_upload_required__c) {
      if (((doc?.document?.length + 1 > 0) || (doc?.document?.url?.length + 1 > 0)) && (doc?.document || [])?.length + 1 > 0) {
        validated = true
      }
      else{
        validated = false
      }
    }
    if ((doc.minimum_doc_upload_required__c && (doc.document || []).length + 1 < doc.minimum_doc_upload_required__c)) {
      validated = false
    }
    if (!(scholarship.status__c === 'Closed' && scholarship.allow_applicant_uploads_after_deadline__c) && !recommenderButton && applicationData.minimum_record_required__c && applicationData.minimum_record_required__c > (applicationData.heroku_role__c ? (applicationData?.references?.length ) : ( iterationCount ))) {
      validated = false
    }
    if (!applicationData.minimum_record_required__c) {
      validated = true
    }
    let applicationsData = { application_data: data, entry_level_check_value__c: applicationData.entry_level_check_value__c, submitted_application_step: validated && !isOtherFieldsValidated || false }

    const response = await API.submitScholarship({ 'token': accountData.token, scholarshipId: scholarshipid, applicationStepId: applicationData.sfid, applicationsData, applicationId: applicationId || '' })
    if (!response.success) {
      toast.error(<FlashMessage type='error' message={parseHtml(response.message) || `Something went wrong.`} />);
      setLoading(false);
    } else if (applicationData.order__c === 1 && !applicationId) {
      let URL = `/apply/${scholarshipid}/${applicationstepid}/${response.application_id}`;
      router.push(URL, undefined, { shallow: true })
      toast.success(<FlashMessage message={`Saved`} />);
  } else {
      toast.success(<FlashMessage message={`Saved`} />);
      localStorage.setItem("isRedireactSave", false)
      fetchApplyScholarship()
    }
  }

  /**
   * Delete Application Question Document
   * @returns {JSX.Element}
   */
  const deleteApplicationDocument  = async (documentId) => {
    setLoading(true);
    let validated = true
    let isOtherFieldsValidated = false
    validationCheck(filterFieldData, 'save', '', (newValue) => { isOtherFieldsValidated = newValue }, 'delete')
    let cloneFilteredData = JSON.parse(JSON.stringify(filterFieldData));
    cloneFilteredData.forEach((row) => {
      if ((row.required__c && allDocType.includes(row.data_type__c)) || row.doc_upload_required__c) {
        if (((row?.document?.length < 2) || (row?.document?.url?.length < 2)) && (row.document || [])?.length < 2) {
          validated = false
        }
      }
      if (row.minimum_doc_upload_required__c && (row.document || []).length - 1 < row.minimum_doc_upload_required__c) {
        validated = false
      }
    })
   
    const response = await API.deleteApplicationDocument({
      'token': accountData.token,
      scholarshipId: scholarshipid,
      applicationStepId: applicationData.sfid,
      applicationId: application.sfid || application.heroku_id__c,
      documentId: documentId,
      submitted_application_step: validated && !isOtherFieldsValidated || false
    })
    if (!response.success) {
      toast.error(<FlashMessage type='error' message={parseHtml(response.message) || `Something went wrong.`} />);
      setLoading(false);
    } else if (applicationData && !applicationId) {
      let URL = `/apply/${scholarshipid}/${applicationstepid}/${application.sfid || application.heroku_id__c}`;
      router.push(URL, undefined, { shallow: true });
      toast.success(<FlashMessage message={`Removed`} />);
    } else {
      fetchApplyScholarship()
      toast.success(<FlashMessage message={`Removed`} />);
    }

  }

  var marketPlace = cookies('context').marketPlace;

  const redirectToanotherScreen = () => {
    if (scholarship.enable_auto_logout__c && userContext) {
      document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
      document.cookie = 'context=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
      document.cookie = 'user=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
      document.cookie = 'currentAccount=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
      document.cookie = 'marketPlace=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
      localStorage.clear();
      setTimeout(() => {
        window.location.href = MAIN_CONFIG.URLS.BASE;
      }, 2000);
    } else if (!userContext && marketPlace) {
      window.location.href = `/${marketPlace}`
    } else {
      window.location.href = checkMarketPlace()
    }
  }

  const onConfirmPaymentStep = () => {

    if (scholarship.form_type__c === "Donation Form") {
      redirectToanotherScreen();
      setLoading(true)
    }
    setUpdateAlert(false)
  }
  const setPaymentAlert = (error = false, msg = '') => {
    const getAlert = () => (
      <div id='payment-confirmation-alert'>
      <SweetAlert
        custom
        confirmBtnCssClass="cta-button CTAWhite tertiary"
        // type={error ? 'error' : 'success'}
        title={error ? 'Error!' : 'Success!'}
        // onConfirm={() => this.hideAlert()}
        confirmBtnText="Close"
        confirmBtnBsStyle="primary"
        show={true}
        onConfirm={() => onConfirmPaymentStep()}
        customClass="user-confirmation-alert"
        id="copied-clipboard"
        openAnim="false"
        customIcon={MAIN_CONFIG.STATIC_IMAGE_URL.Success_Icon}
      >
        <p className="user-confirmation-alert__message">
          {
            error ? `${msg || 'Something went wrong, please retry.'}` : 'Payment done'
          }
        </p>
      </SweetAlert>
      </div>
    );
    setUpdateAlert(getAlert())
    setLoading(false);
  }

  const STATUS = ['not_started', 'succeeded', 'active', 'canceled']
  const submitPayment = async (paymentData) => {
    let applicationsData = paymentData


    if (!accountData.token) {
      var first_name = ''
      var last_name = ''
      var email = ''
      filterFieldData.map((question) => {
        let check = question.salesforce_field_value__c || ''
        if (check.split(";").some(c => c == 'Application__c.First_Name__c')) {
          first_name = question.answer
        } else if (check.split(";").some(c => c == 'Application__c.Last_Name__c')) {
          last_name = question.answer
        } else if (check.split(";").some(c => c == 'Application__c.Email_Address__c')) {
          email = question.answer
        }
      })

      let user = { first_name, last_name, email }

      applicationsData.user = user

    }


    // setLoading(true)
    applicationsData.application_data = setParamResponse(filterFieldData)
    const response = await API.submitScholarship({ 'token': accountData.token, scholarshipId: scholarshipid, applicationStepId: applicationData.sfid, applicationsData, applicationId: applicationId || '' })
    if (!response.success) {
      toast.error(<FlashMessage type='error' message={parseHtml(response.message) || `Something went wrong.`} />);
      setLoading(false);
    } else {
      if (STATUS.includes(response.payment_step_info.status)) {
        fetchApplyScholarship()
        setPaymentAlert()
      } else {
        setPaymentAlert(true, response?.data?.message)
      }
      setLoading(false);
    }

  }

  const handleRedirectToResume = async (scholarship) => {
    setLoading(true);

    const isEditingRestricted =
      !scholarship.allow_multiple_applications__c &&
      !scholarship.allow_edit_after_application_submission__c &&
      !scholarship.allow_applicant_uploads_after_deadline__c &&
      !scholarship.access_code_to_edit_after_deadline__c;

    if (
      authToken &&
      router.pathname.startsWith("/apply") &&
      isEditingRestricted
    ) {
      try {
        const scholarshipDetail = await API.fetchScholarshipById({
          token: authToken,
          scholarshipId: scholarship?.sfid,
        });
  
        const appliedApplication = scholarshipDetail?.applied_applications?.[0];
        
        if (appliedApplication && !["Draft", "Prototype", "Incomplete"].includes(appliedApplication.status__c)) {            
          const URL = `/application/${
              scholarshipDetail.scholarship.sfid ||
              scholarshipDetail.scholarship.heroku_id__c
            }/${appliedApplication.sfid || appliedApplication.heroku_id__c}`;
            return handleRedirectHrefUrl(URL);
       }
      } catch (error) {
        console.error("Error fetching scholarship details:", error);
      }
    }
  
    setLoading(false);
  };

  useEffect(() => {
    sessionStorage.removeItem('previousPath')
    var emailAuth = user?.email || ''
    localStorage.setItem("isRedireactSave", false)
    if (emailAuth && !isEmpty(application) && !isEmpty(scholarship) && applicationData && applicationData.enable_document_sign) {
      window.docuSignClick.Clickwrap.render({
        environment: process.env.NEXT_PUBLIC_DOCUSIGN_URL,
        accountId: scholarship.docusign_account_id__c,
        clickwrapId: scholarship.docusign_clickwrap_id__c,
        clientUserId: `Email: ${emailAuth}, Application Name: ${application.name || application.id}, ID: ${Math.random()}`
      }, '#ds-clickwrap');
    }
  }, [])

  // open docuSign popup
  const handleClickOnDocuSignShow = (e) => {
    e.preventDefault();
    setLoading(true);
    let newState = [...fieldData]
    let selfObjNewState = {};
    let input = newState.find(record => record.id == e.target.name)
    input.answer = e.target.value
    var emailAuth = user.email
    const clientUserId = `Email: ${emailAuth}, Application Name: ${application.name || application.id}, ID: ${Math.random()}`;
    window.docuSignClick.Clickwrap.render({
      environment: process.env.NEXT_PUBLIC_DOCUSIGN_URL,
      accountId: scholarship.docusign_account_id__c,
      clickwrapId: scholarship.docusign_clickwrap_id__c,
      clientUserId: clientUserId,
      onMustAgree: function (e) {
        setLoading(false);
      },
      onAgreed: function (event) {
        onChange(input?.id, 'true')
      },
      onDeclined: function (event) {
        // document.body.style.overflow = "auto"
        onChange(input?.id, 'false')
      }


    }, '#ds-terms-of-service');
  }

  // open agreement popup
  const onAgreementShow = (e) => {
    setAgreementModalOpen(true)
    setAgreementFieldName(e.target.name)
  }

  const closeAgreementModal = () => {
    setModalState({ visible: false });
    setAgreementModalOpen(false)
    setAgreementFieldName("")
  }
  const handleClickShowTearmsCondictionModal = (e, question) => {
    setAgreementFieldName(e.target.name)
    setModalState({
      visible: true,
      id: 'recommender__create',
      class: 'application_step_modal',
      content: <TearmsCondition
        handleClose={closeAgreementModal}
        handleSubmit={onAgreementShow}
        agreementFieldName={agreementFieldName ? agreementFieldName : e.target.name}
        applicationData={applicationData}
        aggrementVal={question}
        agreementResponse={agreementResponse}
      />
    });
  }

  const agreementResponse = (id, val, isAccept) => {
    let input = application.steps_data.fields.find(input => input.name === val)
    if (val && input && isAccept) {
      setModalState({ visible: false });
      onChange(input?.id, 'true')
    } else {
      setModalState({ visible: false });
      onChange(input?.id, 'false')
    }
  }

  // ESign api call

  const closeESignDocument = () => {
    setModalState({
      visible: false
    })
  }

  const handleClickEsignShow = async (e, val) => {
    setLoading(true);
    onChange(val.id, "true")
    // e.preventDefault()
    const response = await API.fetchEsignDocumentUrl({
      'token': accountData.token,
      scholarshipId: scholarship.sfid,
      applicationId: application.heroku_id__c
    })
    if (response) {
      setEnvelopeId(response.docusign_envelope_id)
    }
    setModalState({
      visible: true,
      id: 'Esign_docusign_create',
      content: <ESignModal
        handleClose={closeESignDocument}
        // handleSubmit={onAgreementShow}
        // agreementFieldName={agreementFieldName ? agreementFieldName : e.target.name}
        applicationData={applicationData}
        ESignURL={response && response.docusign_url}
      // agreementResponse={agreementResponse}
      />
    });
    setLoading(false);
  }
  const currectStepId = router.query.applicationstepid;
  const referenceRoles = ["Recommender User", "School Counsellor", "NGB", "Third Party Contributor", "Team Member", "Endorser User", "Verifier"]
  const externalRoles = ["Financial Information"]
  /**
   * Render Application Question Input
   * @returns {JSX.Element}
   */

  const renderForm = (applicationData) => {
    if (!applicationData.payment_step__c && !applicationData.enable_iteration__c && !applicationData.heroku_role__c) {
      return (
        <StepConfigForm
          title={applicationData.title__c}
          subTitle={applicationData.description__c}
          // questions={ fieldData }
          questions={filterFieldData}
          setModalState={setModalState}
          agreementResponse={agreementResponse}
          references={[]}
          handleClickOnDocuSignShow={handleClickOnDocuSignShow}
          sfid={accountData.sfid}
          handleClickEsignShow={handleClickEsignShow}
          handleClickShowTearmsCondictionModal={handleClickShowTearmsCondictionModal}
          onChange={onChange}
          deleteApplicationDocument={deleteApplicationDocument}
          errors={errors}
          step={applicationData.order__c}
          emailConfimation={emailConfimation}
          emailConfimationErrors={emailConfimationErrors}
          handleEmailConfirmation={handleEmailConfirmation}
          onSuggestiveSelect={onSuggestiveSelect}
          onQuestionSuggestiveSelect={onQuestionSuggestiveSelect}
          primaryColour={primaryColor}
          handleAddressSelection={handleAddressSelection}
          buttonSecondaryColor={buttonSecondaryColor}
          allowApplicantUploadsAfterDeadline={checkAccessCode}
          onBlur={onBlur}
          isOpenPassword={isOpenPassword}
          handleSetPassword={handleSetPassword}
          password={password}
          state={state}
          thirteenYearAge={thirteenYearAge}
          setThirteenYearAge={setThirteenYearAge}
          applicationId={application.heroku_id__c}
          formattedDate={formattedDate}
          handleSubmit={handleSubmit}
          sections={sections}
          renderFormattedSections={renderFormattedSections}
          handlejumpto={handlejumpto}
          scholarship={scholarship}
          currectStepId={currectStepId}
          submittedSteps = { submittedSteps }
          stepStatus = { stepStatus }
          handleClearEncryptedValue={handleClearEncryptedValue}
          isMobileScreen={isMobileScreen}
          isIpadScreen={isIpadScreen}
        />
      )
    } else if (!applicationData.payment_step__c && applicationData.enable_iteration__c && referenceRoles.includes(applicationData.heroku_role__c)) {
      return (
        <ReferenceRoleForm
          title={applicationData.title__c}
          herokuRoleDisplayName={applicationData.iteration_label__c}
          subTitle={applicationData.description__c}
          relationshipOptions={applicationData.relationship_options__c}
          // questions={ fieldData }
          questions={filterFieldData}
          iteratableStepShowFirst={applicationData.show_iterable_first__c}
          references={recommenderfield}
          sfid={accountData.sfid}
          onChange={onChange}
          errors={errors}
          showRecommenderModal={showRecommenderModal}
          referenceButton={!recommenderButton}
          iterationfield={iterationfield}
          iteration={iterationData}
          handleRecommenderRemove={handleRecommenderRemove}
          maximumRecord={applicationData.maximum_record_required__c}
          deleteApplicationDocument={deleteApplicationDocument}
          buttonSecondaryColor={buttonSecondaryColor}
          allowApplicantUploadsAfterDeadline={checkAccessCode}
          dependentConfigsForVariousSteps={applicationData.dependent_configs_for_various_steps || []}
          applicationId={application.heroku_id__c}
          scholarship={scholarship}
          sections={sections}
          renderFormattedSections={renderFormattedSections}
          currectStepId={currectStepId}
          handlejumpto={handlejumpto}
          submittedSteps = { submittedSteps }
          stepStatus = { stepStatus }
          isMobileScreen={isMobileScreen}
          isIpadScreen={isIpadScreen}
        />
      )
    } else if (!applicationData.payment_step__c && applicationData.enable_iteration__c && externalRoles.includes(applicationData.heroku_role__c)) {
      return (
        <ExternalRoleForm
          title={applicationData.title__c}
          herokuRoleDisplayName={applicationData.iteration_label__c}
          subTitle={applicationData.description__c}
          externalFinancial={externalFinancial}
          questions={filterFieldData}
          iteratableStepShowFirst={applicationData.show_iterable_first__c}
          // questions={ filterFieldData }
          references={recommenderfield}
          iterationfield={iterationfield}
          iteration={iterationData && iterationData.added_questions}
          sfid={accountData.sfid}
          onChange={onChange}
          errors={errors}
          showExtraIterationModal={showExtraIterationModal}
          handleExtraIterationRemove={handleExtraIterationRemove}
          externalButton={true}
          maximumRecord={applicationData.maximum_record_required__c}
          deleteApplicationDocument={deleteApplicationDocument}
          buttonSecondaryColor={buttonSecondaryColor}
          allowApplicantUploadsAfterDeadline={checkAccessCode}
          dependentConfigsForVariousSteps={applicationData.dependent_configs_for_various_steps || []}
          applicationId={application.heroku_id__c}
          scholarship={scholarship}
          sections={sections}
          renderFormattedSections={renderFormattedSections}
          currectStepId={currectStepId}
          handlejumpto={handlejumpto}
          submittedSteps = { submittedSteps }
          stepStatus = { stepStatus }
          isMobileScreen={isMobileScreen}
          isIpadScreen={isIpadScreen}

        />
      )
    } else if (!applicationData.payment_step__c && applicationData.enable_iteration__c) {
      return (
        <IterationForm
          title={applicationData.title__c}
          subTitle={applicationData.description__c}
          iterationLabel={applicationData.iteration_label__c ? `${applicationData.iteration_label__c}` : 'Add'}
          // questions={ fieldData }
          questions={filterFieldData}
          handleClickShowTearmsCondictionModal={handleClickShowTearmsCondictionModal}
          handleClickOnDocuSignShow={handleClickOnDocuSignShow}
          handleClickEsignShow={handleClickEsignShow}
          iterationfield={iterationfield}
          iteratableStepShowFirst={applicationData.show_iterable_first__c}
          iteration={iterationData}
          sfid={accountData.sfid}
          onChange={onChange}
          errors={errors}
          showIterationModal={showIterationModal}
          handleIterationRemove={handleIterationRemove}
          iterationButton={true}
          maximumRecord={applicationData.maximum_record_required__c}
          iterationCount={iterationData && iterationData.added_questions && iterationData.added_questions?.length || 0}
          deleteApplicationDocument={deleteApplicationDocument}
          onSuggestiveSelect={onSuggestiveSelect}
          onQuestionSuggestiveSelect={onQuestionSuggestiveSelect}
          handleAddressSelection={handleAddressSelection}
          buttonSecondaryColor={buttonSecondaryColor}
          allowApplicantUploadsAfterDeadline={checkAccessCode}
          dependentConfigsForVariousSteps={applicationData.dependent_configs_for_various_steps || []}
          applicationId={application.heroku_id__c}
          scholarship={scholarship}
          sections={sections}
          renderFormattedSections={renderFormattedSections}
          currectStepId={currectStepId}
          handlejumpto={handlejumpto}
          submittedSteps = { submittedSteps }
          stepStatus = { stepStatus }
          isMobileScreen={isMobileScreen}
          isIpadScreen={isIpadScreen}
        />
      )
    } else if (applicationData.payment_step__c && (applicationData.payment_source__c === 'Stripe' || applicationData.payment_source__c === null)) {
      if (applicationData.payment_step_info) {
        return (
          <PaymentDetails
            title={applicationData.title__c}
            subTitle={applicationData.description__c}
            paymentPageInfo={applicationData.payment_step_info}
            application={application}
            buttonSecondaryColor={buttonSecondaryColor}
            allowApplicantUploadsAfterDeadline={checkAccessCode}
            applicationId={application.heroku_id__c}
            submittedSteps = { submittedSteps }
            stepStatus = { stepStatus }
          />
        )
      } else {
        return (<>
          {scholarship.form_type__c === "Donation Form" && <StepConfigForm
            title={applicationData.title__c}
            subTitle={applicationData.description__c}
            // questions={ fieldData }
            questions={filterFieldData}
            setModalState={setModalState}
            agreementResponse={agreementResponse}
            references={[]}
            handleClickOnDocuSignShow={handleClickOnDocuSignShow}
            sfid={accountData.sfid}
            handleClickEsignShow={handleClickEsignShow}
            handleClickShowTearmsCondictionModal={handleClickShowTearmsCondictionModal}
            onChange={onChange}
            deleteApplicationDocument={deleteApplicationDocument}
            errors={errors}
            step={applicationData.order__c}
            emailConfimation={emailConfimation}
            emailConfimationErrors={emailConfimationErrors}
            handleEmailConfirmation={handleEmailConfirmation}
            onSuggestiveSelect={onSuggestiveSelect}
            onQuestionSuggestiveSelect={onQuestionSuggestiveSelect}
            isDonationForm={scholarship.form_type__c === "Donation Form"}
            handleAddressSelection={handleAddressSelection}
            buttonSecondaryColor={buttonSecondaryColor}
            allowApplicantUploadsAfterDeadline={checkAccessCode}
            isOpenPassword={isOpenPassword}
            handleSetPassword={handleSetPassword}
            password={password}
            state={state}
            thirteenYearAge={thirteenYearAge}
            setThirteenYearAge={setThirteenYearAge}
            applicationId={application.heroku_id__c}
            submittedSteps = { submittedSteps }
            stepStatus = { stepStatus }
            isMobileScreen={isMobileScreen}
            isIpadScreen={isIpadScreen}
          />}
          <StripeProvider apiKey={scholarship.stripe_api_key__c}>
            <Checkout
              title={applicationData.title__c}
              subTitle={applicationData.description__c}
              hideMinimumAmount={applicationData.hide_minimum_amount__c}
              match={'Stripe'}
              application={applicationData}
              step={applicationData.order__c}
              current_step={applicationData.order__c}
              setPaymentAlert={setPaymentAlert}
              submitPayment={submitPayment}
              applicationstepid={applicationstepid}
              setLoading={setLoading}
              buttonSecondaryColor={buttonSecondaryColor}
              allowApplicantUploadsAfterDeadline={checkAccessCode}
              formType={scholarship.form_type__c}
              validationCheck={validationCheck}
              fieldData={filterFieldData}
              applicationId={application.heroku_id__c}
              submittedSteps = { submittedSteps }
              stepStatus = { stepStatus }
              accountData={accountData}
            />
          </StripeProvider>
        </>
        )
      }
    } else if (applicationData.payment_step__c && applicationData.payment_source__c === 'Braintree') {
      // return (
      //   <Braintree

      //   />
      // )
    } else {
      return null
    }
  }

  /**
   * Adds the modal content and shows the modal.
   */
  const showRecommenderModal = (e, fields = [], data, type) => {
    localStorage.setItem("isModalOpen", true)
    // if (e.detail == 0) {
    //   e.preventDefault()
    //   return false
    // }
    e.preventDefault()
    let checkType = ['edit', 'view rec']
    var newfields = []
    var newfieldMerged = []
    if (fields?.length > 0) {
      newfields = fields.filter(item => item.config_type__c !== 'Field')
      newfieldMerged = newfields
    }

    let object = {
      email: '',
      first_name: '',
      last_name: '',
      message: applicationData.pre_filled_message__c || '',
      relationship: '',
      question_set_number: (recommenderfield?.length === 0) ? 1 : recommenderfield?.length + 1
    }

    if (checkType.includes(type)) {
      object = {
        email: data.email,
        first_name: data.first_name,
        last_name: data.last_name,
        message: data.message,
        relationship: (applicationData.type_of_relationship__c === 'Picklist') ? { label: data.relationship, value: data.relationship } : data.relationship,
        id: data.id,
        question_set_number: data.question_set_number
      }
      if (data.fields?.length > 0) {
        newfieldMerged = newfields.concat(...data.fields)
      }
    }
    newfieldMerged.sort(function (a, b) {
      return a.order__c - b.order__c;
    });

    let MSG_TEXT = applicationData.endorser_ngb_message_box_text__c || "By clicking submit, a message with instructions for your reference to follow will be sent. No need to send any additional information to your reference. You may add a personal note in the field above that will be included."

    const filteredQuestions = hideQuestionFiltered(iterationfield, userContext)
    const filteredEditQuestions = hideQuestionFiltered(newfieldMerged, userContext)

    setModalState({
      visible: true,
      id: 'recommender__create',
      class: 'application_step_modal',
      content: <RecommenderModal
        handleClose={closeRecommenderModal}
        handleSubmit={handleRecommenderSubmit}
        questions={(type === 'new' ? filteredQuestions : filteredEditQuestions)}
        onChange={onChange}
        staticObj={object}
        applicationDependentConfigs={application.dependent_configs}
        herokuRole={applicationData.heroku_role_display_name__c || applicationData.heroku_role__c}
        MsgText={MSG_TEXT}
        type={type}
        emailAuth={user.email}
        recommenderList={recommenderfield}
        dependentConfigsForVariousSteps={applicationData.dependent_configs_for_various_steps || []}
        relationshipOptions={applicationData.relationship_options__c || ''}
        relationshipType={applicationData.type_of_relationship__c || 'Text'}
        relationshipFieldVisible={applicationData.relationship_field_visible__c}
        allowApplicantUploadsAfterDeadline={checkAccessCode}
        alretMsg={alretMsg}
        applicationId={application.heroku_id__c}
      />
    });
  }

  /**
   * Closes the modal.
   */
  const closeRecommenderModal = () => {
    localStorage.removeItem("isModalOpen")
    setModalState({ visible: false });
  }

  // TODO: remove recommender.
  const handleRecommenderRemove = async (e, recommenderId) => {
    // setLoading(true);
    let submittedApplicationsStep = true
    if (!(scholarship.status__c === 'Closed' && scholarship.allow_applicant_uploads_after_deadline__c) && !recommenderButton && applicationData.minimum_record_required__c && applicationData.minimum_record_required__c > (applicationData.heroku_role__c ? applicationData?.references?.length - 1 : iterationData?.added_questions?.length - 1)) {
      submittedApplicationsStep = false
    }
    if (!applicationData.minimum_record_required__c) {
      submittedApplicationsStep = true
    }
    let validated = false
    validationCheck(filterFieldData, 'save', '', (newValue) => { validated = newValue })
    e.preventDefault()
    const response = await API.deleteScholarshipReference({
      'token': accountData.token,
      scholarshipId: scholarshipid,
      applicationStepId: applicationData.sfid,
      applicationId: applicationId,
      referenceId: recommenderId,
      submitted_application_step:submittedApplicationsStep && !validated || false
    })
    if (!response.success) {
      toast.error(<FlashMessage type='error' message={parseHtml(response.message) || `Something went wrong.`} />);
      setLoading(false);
    } else {
      toast.success(<FlashMessage message={`Removed`} />);
      fetchApplyScholarship()
    }
    setLoading(false);
  }

  // TODO: Validate, save, submit application.
  const handleRecommenderSubmit = async (referrence, recommenderData, type) => {
    localStorage.removeItem("isModalOpen")
    setLoading(true);
    let fieldparam = []
    if (filterFieldData?.length > 0) {
      fieldparam = setParamResponse(filterFieldData)
    }
    let data = []
    let dataField = []
    recommenderData.map((row) => {
      if (row.answer && row.data_type__c === "Currency") {
        row.answer = (row.config_type__c === 'Field') ? row.answer.toString().split(',').join('') : formatCurrency(row.answer, row?.currency_symbol__c || 'USD');
      }
      if (row.config_type__c === 'Field') {
        if (row.answer && (Array.isArray(row.answer) || row.answer.value)) {
          if (row.data_type__c === 'Picklist' || row.data_type__c === "Dependent Picklist") {
            if (Array.isArray(row.answer)) {
              dataField.push({ sfid: row.sfid, answer: row.answer[0].value, question_set_number: referrence.question_set_number })
            } else {
              dataField.push({ sfid: row.sfid, answer: row.answer.value, question_set_number: referrence.question_set_number })
            }
          } else if (dataTypeJoin.includes(row.data_type__c)) {
            dataField.push({ sfid: row.sfid, answer: row.answer.join(';'), question_set_number: referrence.question_set_number })
          }
        } else {
          dataField.push({ sfid: row.sfid, answer: row.answer || '', question_set_number: referrence.question_set_number })
        }
      } else {
        if (row.answer && (Array.isArray(row.answer) || row.answer.value)) {
          if (row.data_type__c === 'Picklist' || row.data_type__c === "Dependent Picklist") {
            if (Array.isArray(row.answer)) {
              data.push({ sfid: row.sfid, answer: row.answer[0].value, question_set_number: referrence.question_set_number, document: documentHandling(type, row.document) })
            } else {
              data.push({ sfid: row.sfid, answer: row.answer.value, question_set_number: referrence.question_set_number, document: documentHandling(type, row.document) })
            }
          } else if (dataTypeJoin.includes(row.data_type__c)) {
            data.push({ sfid: row.sfid, answer: row.answer.join(';'), question_set_number: referrence.question_set_number, document: documentHandling(type, row.document) })
          }
        } else {
          data.push({ sfid: row.sfid, answer: row.answer || '', question_set_number: referrence.question_set_number, document: documentHandling(type, row.document) })
        }
      }

    })
    let id = referrence.id

    delete referrence.id;  // or delete person["age"];
    delete referrence.email_confirmation;  // or delete person["age"];
    let heroku_role_data = {
      fields: dataField,
      id: id || '',
      reference: referrence
    }

    const submitRecords = applicationFormAutoSuggestHiddenConfigs(fieldData, fieldparam.concat(...data))
  
    let submittedApplicationStep = false
    let length = type === 'new' ? 1 : 0
    let iterationCount= iterationData && iterationData.added_questions && iterationData.added_questions?.length + 1
    if (!(scholarship.status__c === 'Closed' && scholarship.allow_applicant_uploads_after_deadline__c) && !recommenderButton && applicationData.minimum_record_required__c && applicationData.minimum_record_required__c <= (applicationData.heroku_role__c ? (applicationData?.references?.length + length) : (type === 'new' ? iterationCount : iterationCount - 1))) {
      submittedApplicationStep = true
    }
    if (!applicationData.minimum_record_required__c) {
      submittedApplicationStep = true
    }
    let validated = false
    validationCheck(filterFieldData, 'save', '', (newValue) => { validated = newValue }, type)
    let applicationsData = { application_data: submitRecords, heroku_role_data: heroku_role_data, submitted_application_step: submittedApplicationStep && !validated || false }



    const response = await API.submitScholarship({ 'token': accountData.token, scholarshipId: scholarshipid, applicationStepId: applicationData.sfid, applicationsData, applicationId: applicationId || '' })
    if (!response.success) {
      toast.error(<FlashMessage type='error' message={parseHtml(response.message) || `Something went wrong.`} />);
      setLoading(false);
    } else {
      closeRecommenderModal()
      toast.success(<FlashMessage message={`Saved`} />);
      localStorage.setItem("isRedireactSave", false)
      fetchApplyScholarship()
    }
  }


  /**
   * Adds the modal content and shows the modal.
   */
  const showIterationModal = (e, iteration, type) => {
    localStorage.setItem("isModalOpen", true);
    // if (e.detail == 0) {
    //   e.preventDefault()
    //   return false
    // }
    e.preventDefault()
    let question = cloneDeep(iteration)
    if (type === 'new') {
      let setNumber = iterationData.added_questions?.length
      question.filter(r => {
        if (r.auto_populate_from_config__c) {
          r.answer = autoPopulateAnswersFromConfig(r.auto_populate_from_config__c, applicationData.auto_populate_from_config_answers, setNumber)
        }
      })
    }

    const filteredQuestions = hideQuestionFiltered(question, userContext)

    setModalState({
      visible: true,
      id: 'recommender__create',
      class: `application_step_modal ${isOpenSweetAlert && ''}`,
      content: <IterationModal
        handleClose={closeIterationModal}
        handleSubmit={handleIterationSubmit}
        loading={loading}
        questions={filteredQuestions}
        filterFieldData={filterFieldData}
        setModalState={setModalState}
        type={type}
        applicationDependentConfigs={application.dependent_configs}
        dependentConfigsForVariousSteps={applicationData.dependent_configs_for_various_steps || []}
        allowApplicantUploadsAfterDeadline={checkAccessCode}
        onSuggestiveSelect={onSuggestiveSelect}
        onQuestionSuggestiveSelect={onQuestionSuggestiveSelect}
        setFieldData={setFieldData}
        setErrors={setErrors}
        applicationData={applicationData}
        alretMsg={alretMsg}
        applicationId={application.heroku_id__c}
        allowHtmlTags={true}
      />
    });
  }

  /**
   * Adds the modal content and shows the modal.
   */
  const showExtraIterationModal = (e, iteration, type) => {
    // if (e.detail == 0) {
    //   e.preventDefault()
    //   return false
    // }
    e.preventDefault()
    setModalState({
      visible: true,
      id: 'recommender__create',
      class: 'application_step_modal',
      content: <IterationModal
        allowApplicantUploadsAfterDeadline={checkAccessCode}
        handleClose={closeIterationModal}
        handleSubmit={handleExtraIterationSubmit}
        onSuggestiveSelect={onSuggestiveSelect}
        onQuestionSuggestiveSelect={onQuestionSuggestiveSelect}
        questions={iteration}
        onChange={onChange}
        type={type}
        applicationId={application.heroku_id__c}
      />
    });
  }

  /**
   * Closes the modal.
   */
  const closeIterationModal = () => {
    localStorage.removeItem("isModalOpen")
    setModalState({ visible: false });
    setIsOpenSweetAlert(false)
  }

  /**
   * Closes the modal.
   */
  const documentHandling = (type, document) => {
    let documentData = []
    if (type === 'new' && document) {
      documentData = document
    } else if (type !== 'new' && document?.length > 0) {
      documentData = document[0]?.heroku_id__c ? [] : document[0]
    } else {
      documentData = document
    }
    return documentData
  }

  // TODO: Validate, save, submit application.
  const handleIterationSubmit = async (iterationsData, type) => {
    localStorage.removeItem("isModalOpen")
    let iterationtype = fieldData.find(iteration => iteration.data_type__c === 'Iteration Count' && !iteration.enable_iteration__c)?.id;
    let iterationCount= iterationData && iterationData.added_questions && iterationData.added_questions.length + 1
    let updateIterationcount=iterationtype && type==='new'
    setLoading(true);
    let fieldparam = []
    if (filterFieldData?.length > 0) {
      fieldparam = setParamResponse(filterFieldData)
    }

    let question_set_number = 1
    if (iterationData.added_questions?.length === 0) {
      question_set_number = 1
    } else {
      question_set_number = iterationData.added_questions.pop()[0].question_set_number + 1
    }

    let data = []

    iterationsData.map((row) => {
      if (row.answer && row.data_type__c === "Currency") {
        row.answer = (row.config_type__c === 'Field') ? row.answer.toString().split(',').join('') : formatCurrency(row.answer, row?.currency_symbol__c || 'USD');
      }
      if (row.answer && (Array.isArray(row.answer) || row.answer.value)) {
        if (row.data_type__c === 'Picklist' || row.data_type__c === "Dependent Picklist") {
          if (Array.isArray(row.answer)) {
            data.push({ sfid: row.sfid, answer: row.answer[0].value, question_set_number: (type === 'new') ? question_set_number : row.question_set_number, document: documentHandling(type, row.document) })
          } else {
            data.push({ sfid: row.sfid, answer: row.answer.value, question_set_number: (type === 'new') ? question_set_number : row.question_set_number, document: documentHandling(type, row.document) })
          }
        } else if (dataTypeJoin.includes(row.data_type__c)) {
          data.push({ sfid: row.sfid, answer: row.answer.join(';'), question_set_number: (type === 'new') ? question_set_number : row.question_set_number, document: documentHandling(type, row.document) })
        }
      } else {
        data.push({ sfid: row.sfid, answer: row.answer || '', question_set_number: (type === 'new') ? question_set_number : row.question_set_number, document: documentHandling(type, row.document) })
      }

    })
    const submitRecords = applicationFormAutoSuggestHiddenConfigs(fieldData, fieldparam.concat(...data))
    // let applicationsData = { application_data: submitRecords }

    // const response = await API.submitScholarship({ 'token': accountData.token, scholarshipId: scholarshipid, applicationStepId: applicationData.sfid, applicationsData, applicationId: applicationId || '' })
    let length = type === 'new' ? 1 : 0
    let submittedApplicationStep = false
    if (!(scholarship.status__c === 'Closed' && scholarship.allow_applicant_uploads_after_deadline__c) && !recommenderButton && applicationData.minimum_record_required__c && applicationData.minimum_record_required__c <= (applicationData.heroku_role__c ? (applicationData?.references?.length + length) : (type === 'new' ? iterationCount : iterationCount - 1))) {
      submittedApplicationStep = true
    }
    if (!applicationData.minimum_record_required__c) {
      submittedApplicationStep = true
    }
    let validated = false
    validationCheck(filterFieldData, 'save', '', (newValue) => { validated = newValue }, type)
    let applicationsData = { application_data: submitRecords, submitted_application_step: submittedApplicationStep && !validated || false }
    const response = await API.submitScholarship({ 'token': accountData.token, scholarshipId: scholarshipid, applicationStepId: applicationData.sfid, applicationsData, applicationId: applicationId || '' })

    if (!response.success) {
      toast.error(<FlashMessage type='error' message={parseHtml(response.message) || `Something went wrong.`} />);
      setLoading(false);
    } else {
      closeIterationModal()
      toast.success(<FlashMessage message={`Saved`} />);
      localStorage.setItem("isRedireactSave", false)
      fetchApplyScholarship('', updateIterationcount ? () => onChange(iterationtype, iterationCount) : () => {})
    }
  }


  // TODO: remove recommender.
  const handleIterationRemove = async (e, questionSetNumber) => {
    let iterationtype=fieldData.find(iteration=>iteration.data_type__c==='Iteration Count' && !iteration.enable_iteration__c)?.id
    let iterationCount= iterationData && iterationData.added_questions && iterationData.added_questions?.length - 1
    let submittedApplicationsStep = true
    if (!(scholarship.status__c === 'Closed' && scholarship.allow_applicant_uploads_after_deadline__c) && !recommenderButton && applicationData.minimum_record_required__c && applicationData.minimum_record_required__c > (applicationData.heroku_role__c ? applicationData?.references?.length - 1 : iterationData?.added_questions?.length - 1)) {
      submittedApplicationsStep = false
    }
    let validated = false
    validationCheck(fieldData, 'save', '', (newValue) => { validated = newValue })
    e.preventDefault()
    setLoading(true);
    const response = await API.deleteScholarshipIteration({
      'token': accountData.token,
      scholarshipId: scholarshipid,
      applicationStepId: applicationData.sfid,
      applicationId: applicationId,
      questionSetNumber: questionSetNumber,
      submitted_application_step:submittedApplicationsStep && !validated || false
    })
    if (!response.success) {
      toast.error(<FlashMessage type='error' message={parseHtml(response.message) || `Something went wrong.`} />);
      setLoading(false);
      
    } else {
      localStorage.setItem("isRedireactSave", true)
      toast.success(<FlashMessage message={`Removed`} />);
      fetchApplyScholarship('', iterationtype ? () => onChange(iterationtype, iterationCount) : () => {})
    }
  }

  // TODO: Validate, save, submit application.
  const handleExtraIterationSubmit = async (iterationsData, type) => {
    setLoading(true);
    let question_set_number = 1
    if (iterationData.added_questions?.length === 0) {
      question_set_number = 1
    } else {
      question_set_number = iterationData.added_questions.pop()[0].question_set_number + 1
    }

    let financialInformationID = ''
    let data = []
    let dataField = []
    iterationsData.map((row) => {

      if (row.config_type__c === 'Field') {

        question_set_number = (type === 'new') ? question_set_number : row.question_set_number

        if (row.answer && (Array.isArray(row.answer) || row.answer.value)) {
          if (row.data_type__c === 'Picklist' || row.data_type__c === "Dependent Picklist") {
            if (Array.isArray(row.answer)) {
              dataField.push({ sfid: row.sfid, answer: row.answer[0].value, question_set_number: (type === 'new') ? question_set_number : row.question_set_number })
            } else {
              dataField.push({ sfid: row.sfid, answer: row.answer.value, question_set_number: (type === 'new') ? question_set_number : row.question_set_number })
            }
          } else if (dataTypeJoin.includes(row.data_type__c)) {
            dataField.push({ sfid: row.sfid, answer: row.answer.join(';'), question_set_number: (type === 'new') ? question_set_number : row.question_set_number })
          }
        } else {
          dataField.push({ sfid: row.sfid, answer: row.answer || '', question_set_number: (type === 'new') ? question_set_number : row.question_set_number })
        }

        financialInformationID = row.financial_information_id
      } else {
        if (row.answer && (Array.isArray(row.answer) || row.answer.value)) {
          if (row.data_type__c === 'Picklist' || row.data_type__c === "Dependent Picklist") {
            if (Array.isArray(row.answer)) {
              data.push({ sfid: row.sfid, answer: row.answer[0].value, question_set_number: (type === 'new') ? question_set_number : row.question_set_number })
            } else {
              data.push({ sfid: row.sfid, answer: row.answer.value, question_set_number: (type === 'new') ? question_set_number : row.question_set_number })
            }
          } else if (dataTypeJoin.includes(row.data_type__c)) {
            data.push({ sfid: row.sfid, answer: row.answer.join(';'), question_set_number: (type === 'new') ? question_set_number : row.question_set_number })
          }
        } else {
          data.push({ sfid: row.sfid, answer: row.answer || '', question_set_number: (type === 'new') ? question_set_number : row.question_set_number })
        }
      }

    })

    let heroku_role_data = {
      fields: dataField,
      id: (type === 'new') ? '' : financialInformationID,
      reference: []
    }
    data = applicationFormAutoSuggestHiddenConfigs(fieldData, data)
    let iterationCount = iterationData && iterationData.added_questions && iterationData.added_questions?.length + 1
    let length = type === "new" ? 1 : 0
    let submittedApplicationStep = false
    if (!(scholarship.status__c === 'Closed' && scholarship.allow_applicant_uploads_after_deadline__c) && !recommenderButton && applicationData.minimum_record_required__c && applicationData.minimum_record_required__c <= (applicationData.heroku_role__c ? (applicationData?.references?.length + length) : (type === 'new' ? iterationCount : iterationCount - 1))) {
      submittedApplicationStep = true
    }
    if (!applicationData.minimum_record_required__c) {
      submittedApplicationStep = true
    }
    let validated = false
    validationCheck(iterationsData, 'save', '', (newValue) => { validated = newValue })
    let applicationsData = { application_data: data, heroku_role_data: heroku_role_data, submitted_application_step: submittedApplicationStep && !validated || false }
    const response = await API.submitScholarship({ 'token': accountData.token, scholarshipId: scholarshipid, applicationStepId: applicationData.sfid, applicationsData, applicationId: applicationId || '' })

    if (!response.success) {
      toast.error(<FlashMessage type='error' message={parseHtml(response.message) || `Something went wrong.`} />);
      setLoading(false);
    } else {
      closeIterationModal()
      toast.success(<FlashMessage message={`Saved`} />);
      localStorage.setItem("isRedireactSave", false)
      fetchApplyScholarship()
    }
  }


  // TODO: remove recommender.
  const handleExtraIterationRemove = async (e, extraIterationId) => {

    setLoading(true);
    e.preventDefault()
    let submittedApplicationsStep = true
    if (!(scholarship.status__c === 'Closed' && scholarship.allow_applicant_uploads_after_deadline__c) && !recommenderButton && applicationData.minimum_record_required__c && applicationData.minimum_record_required__c > (applicationData.heroku_role__c ? applicationData?.references?.length - 1 : iterationData?.added_questions?.length - 1)) {
      submittedApplicationsStep = false
    }
    const response = await API.deleteScholarshipReference({
      'token': accountData.token,
      scholarshipId: scholarshipid,
      applicationStepId: applicationData.sfid,
      applicationId: applicationId,
      referenceId: extraIterationId,
      submitted_application_step:submittedApplicationsStep
    })
    if (!response.success) {
      toast.error(<FlashMessage type='error' message={parseHtml(response.message) || `Something went wrong.`} />);
      setLoading(false);
    } else {
      toast.success(<FlashMessage message={`Removed`} />);
      fetchApplyScholarship()
    }
  }

  // Function to get formatted deadline Date
  const getFormattedDate = (deadlineDateTime) => {
    return deadlineDateTime ? formatDeadlineDate(new Date(deadlineDateTime)) : '';
  }
  const formattedDate = getFormattedDate(scholarship.deadline_date_time);

  // Function to determine the dynamic id for desktop and Ipad view
  const getDynamicId = (getTrue, customId) => {
    if (getTrue) {
      return customId;
    }
    return null;
  }

// Function to determine the header top color based on primary color and conversion
const headerTopColor = () => {
  if (primaryColorConvert === '#ffffff') {
    return '#000000';
  } else if (primaryColor) {
    return primaryColor;
  } else {
    return '#008067';
  }
};

// Function to get dynamic style based on primary color
 const applicationHeaderStyle = getDynamicClassName(primaryColor,
    {
      borderTop: `15px solid ${headerTopColor()}`,
      borderRadius: '5px',
    }, {
    borderTop: '15px solid #008067',
    borderRadius: '5px',
  })

  // Function to get dynamic button based on next_step_id
  const updateButtonText = () => {
    if (application.next_step_id) {
      return 'Next'
    } else {
      return 'Review'
    }
  }

  const renderApplicationHederContent = () => {
    return (
      <ApplicationHeader
        logoUrl={scholarship.scholarshiplogourl__c}
        title={scholarship.name}
        buttonSecondaryColor={buttonSecondaryColor}
        handleClose={close}
        scholarshipHeaderLogo={scholarship.scholarship_header_logo_url__c}
        applicationData={applicationData}
        handleSubmit={handleSubmit}
        application={application}
        scholarship={scholarship}
        formattedDate={formattedDate}
        setIsOpenSweetAlert={setIsOpenSweetAlert}
        setLoading={setLoading}
      />
    )
  }

  return (
    <div className={`application application_resume`}>
      <div className='application-left-side-header-content'>
        <div className='left-side-content'>
        {renderApplicationHederContent()}
        </div>
      </div>

      <div className='application__inner' id={getDynamicId(!(isMobileScreen), 'application-form-content-data')} style={applicationHeaderStyle}>
        <style jsx global>{`.application-section__question a, .application-section__subtitle a, .application-section__title a, .application-section__subtitle a, .summery-page-review-text a {color: ${buttonSecondaryColor}}`} </style>

        <Loader loading={loading} />
        {updateAlert}
        {scholarship.total_steps &&
          <div className="application__content">
            {isMobileScreen &&
              renderApplicationHederContent()
            }

            {renderForm(applicationData)}

            <div className='footer-button-container'>
              <div className='left-gap'></div>
              {scholarship.form_type__c !== "Donation Form" &&
                <div className="application-step-form-container" id={getDynamicId((!isMobileScreen && action !== 'completed'), 'application-form-action-button-container')}>
                  <div className="application-step-form-container__previous-step" id={getDynamicId(isMobileScreen, 'mobile-view-previous-page-btn')}>
                    {applicationData.order__c > 1 &&
                      <CTAButton
                        className="transparent-CTAButton"
                        onClick={handlePrevious}
                        arrow={true}
                        reverse={true}
                        type="tertiary"
                        arrowAriaLabelDescription=""
                      >
                        Back
                      </CTAButton>
                    }
                  </div>
                  <div className="application-step-form-container__step-current-status">
                    <div className="CTABlack">
                      Page  {applicationData.order__c} of {scholarship.total_steps + 1}
                    </div>
                  </div>
                  <div className="application-step-form-container__next-step">
                    {applicationData.order__c <= scholarship.total_steps &&
                      <>

                          <div className='save-application-button'>
                            <CTAButton
                              className="application__submit-trigger save-application"
                              onClick={(e) => handleSubmit(e, 'save')}
                              type="tertiary"
                              disabled={applicationData.payment_step__c ? !(applicationData.payment_step__c && applicationData.payment_step_info) : ''}
                            >
                              Save
                            </CTAButton>
                          </div>

                        <div className='next-page-and-review-submit-btn'>
                          <CTAButton
                            className="transparent-CTAButton next-page-button"
                            onClick={(e) => handleSubmit(e, 'next')}
                            arrow={true}
                            type={"tertiary"}
                            arrowAriaLabelDescription=""
                            disabled={applicationData.payment_step__c ? !(applicationData.payment_step__c && applicationData.payment_step_info) : ''}
                          >
                            {updateButtonText()}
                          </CTAButton>
                        </div>
                      </>
                    }
                  </div>
                </div>
              }
              <div className='right-gap'></div>
            </div>

          </div>
        }
        {isOpenSweetAlert}
      </div>

      {
        applicationId && scholarship.allow_to_view_entire_steps__c && !isIpadScreen && !isMobileScreen &&
        <div className='jump-to-section-container custom-scrollbar'>
          <JumptoSection
            handlejumpto={handlejumpto}
            currectStepId={currectStepId}
            getSections={renderFormattedSections(sections)}
            buttonSecondaryColor={buttonSecondaryColor}
            submittedSteps={submittedSteps}
            stepStatus={stepStatus}
          />
        </div>
      }
    </div>
  )
}

// Define prop types
Application.propTypes = {
  accountData: PropTypes.shape({
    user: PropTypes.shape({
      primary_guardian_signature__c: PropTypes.bool,
    }),
  }),
};

export default reduxPage(Application)